
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2xwXF", function(module, exports) {

var $glMUq = parcelRequire("glMUq");

const $8275702e0ac0e8a0$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $glMUq.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
module.exports["getClickUrl"] = $8275702e0ac0e8a0$export$cf3c5acf9e9d0f02;

});

parcelRegister("glMUq", function(module, exports) {
const $7c407c37ca6df037$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};
module.exports["extractVisitUrl"] = $7c407c37ca6df037$export$c81497d3681f24f4;

});

parcelRegister("dz9dk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b4SfK = parcelRequire("b4SfK");


var $bI14T = parcelRequire("bI14T");


var $2fpc3 = parcelRequire("2fpc3");


var $i2E3t = parcelRequire("i2E3t");

const $decb67059ffe42ce$export$119a84bedaff7b6e = ({ details: details })=>{
    const { product: product, bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $bI14T.useSmartLinkContext)();
    // xpcProduct takes precedence over product — it identifies the host product for XPC analytics
    // without affecting link resolution (which uses the `product` prop separately).
    const effectiveProduct = xpcProduct ?? product;
    const effectiveBridge = bridgeProduct ?? (0, $2fpc3.XPC_CONSTANTS).SMART_LINKS_XPC_BRIDGE;
    const effectiveProductForWrapper = effectiveProduct?.toLowerCase() ?? 'unknown';
    const wrapUrl = (0, $b4SfK.useCrossProductUrlWrapper)({
        bridge: effectiveBridge,
        product: effectiveProductForWrapper,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    return (0, $cozmU.useCallback)((url)=>{
        if (typeof window === 'undefined' || !(0, $i2E3t.getIsFirstPartyLink)(details) || !effectiveProduct) return url;
        let parsedUrl;
        try {
            parsedUrl = new URL(url);
        } catch  {
            return url;
        }
        if (parsedUrl.searchParams.has((0, $2fpc3.XPC_CONSTANTS).QUERY_PARAM)) return url;
        return wrapUrl(url);
    }, // Keep bridge/subproduct in the dependency array so consumers that memoize this callback
    // refresh when mini-modal context updates from smartLinks to rovo-chat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        details,
        effectiveBridge,
        effectiveProduct,
        wrapUrl,
        xpcSubProduct
    ]);
};
module.exports["useSmartLinkCrossProductUrlWrapper"] = $decb67059ffe42ce$export$119a84bedaff7b6e;

});

parcelRegister("b4SfK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $2pQiO = parcelRequire("2pQiO");


var $kwd5f = parcelRequire("kwd5f");


var $3jjX7 = parcelRequire("3jjX7");

const $94cb50462294ed69$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * Kill switch config, defaults to enabled so we fail open if the config can't be resolved.
 * https://switcheroo.atlassian.com/ui/configurations/d3b9839b-0a19-4f81-928e-44fc4fac4c55/key/atlaskit-analytics-cross-product-kill-switch
 */ const $94cb50462294ed69$var$KILL_SWITCH_CONFIG = 'atlaskit-analytics-cross-product-kill-switch';
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $94cb50462294ed69$export$fc6e9265f8d85c92(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    // This is a kill switch rather than an experiment, so no exposure is fired.
    const isEnabled = !(0, $2pQiO.UNSAFE_expValNoExposure)($94cb50462294ed69$var$KILL_SWITCH_CONFIG, 'value', false);
    // `useRef(initialValue)` evaluates `initialValue` on every render but only uses the result on
    // the first render. Populate the ref imperatively the first time we need it so we don't call
    // `getInstance()` on every render (per Billy Chen's review suggestion).
    const interactionSessionClientRef = (0, $cozmU.useRef)(undefined);
    if (isEnabled && !interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
    const [interactionSessionId, setInteractionSessionId] = (0, $cozmU.useState)(()=>interactionSessionClientRef.current?.getCurrentInteractionSessionId() ?? '');
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return ()=>{};
        // Add event listener that subscribes to any future interaction session ID updates
        const unbind = (0, $cbY7C.bind)(document, {
            type: $94cb50462294ed69$export$5d4c4eab0863aae3,
            listener: ()=>{
                // Re-attempt fetch Global interactionSessionClient if not present already
                if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
                if (interactionSessionClientRef.current) {
                    const currentSessionId = interactionSessionClientRef.current.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            }
        });
        return unbind;
    }, [
        isEnabled
    ]);
    return (0, $cozmU.useCallback)((url)=>{
        if (!isEnabled || !interactionSessionId) return url;
        return (0, $kwd5f.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
    }, [
        isEnabled,
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
}
var $94cb50462294ed69$export$2e2bcd8739ae039 = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["useCrossProductUrlWrapper"] = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["default"] = $94cb50462294ed69$export$2e2bcd8739ae039;

});

parcelRegister("kwd5f", function(module, exports) {
const $8f3492c0e77dd422$export$81d16f1428ce0486 = 'xpis';
const $8f3492c0e77dd422$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($8f3492c0e77dd422$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};
module.exports["generateUrlWithParams"] = $8f3492c0e77dd422$export$2e3999ec51334ffe;

});

parcelRegister("2fpc3", function(module, exports) {
const $fc533d0826d763e5$export$77dc2792a6ac896b = {
    SMART_LINKS_XPC_BRIDGE: 'smartLinks',
    QUERY_PARAM: 'xpis'
};
module.exports["XPC_CONSTANTS"] = $fc533d0826d763e5$export$77dc2792a6ac896b;

});

parcelRegister("i2E3t", function(module, exports) {
const $7df68cd3597971e3$export$189e6ab4f1c74893 = (details)=>(details?.meta?.is1PLink ?? false) === true;
module.exports["getIsFirstPartyLink"] = $7df68cd3597971e3$export$189e6ab4f1c74893;

});

parcelRegister("9ojsk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");

const $1b16e3a991f1098a$export$c3514c024fefef57 = ()=>{
    const context = (0, $bI14T.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $cozmU.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};
module.exports["useSmartLinkRenderers"] = $1b16e3a991f1098a$export$c3514c024fefef57;

});

parcelRegister("4TMNS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6fy9Y = parcelRequire("6fy9Y");


var $hsgLh = parcelRequire("hsgLh");

const $6d8b35e63d678f3a$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $cozmU.useState)(null);
    const api = (0, $cozmU.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fy9Y.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $cozmU.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $cozmU.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsgLh.SmartLinkModalContext).Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
module.exports["SmartLinkModalProvider"] = $6d8b35e63d678f3a$export$bb4eb02a83e1a0f8;

});

parcelRegister("6fy9Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $a4b4c858d51f1d19$var$styles = {
    wrapper: "_0NUa3rdnbC _1EqgXldnbC _1mT5xdWVPG"
};
const $a4b4c858d51f1d19$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $cozmU.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        role: "none",
        xcss: $a4b4c858d51f1d19$var$styles.wrapper,
        onClick: onClick
    }, children);
};
module.exports["StopPropagation"] = $a4b4c858d51f1d19$export$3e100bc08448f36c;

});

parcelRegister("izOnk", function(module, exports) {
const $dc343e06d9ce05a3$export$bd1e92a09497f497 = (event)=>{
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLAnchorElement)) return {
        href: undefined,
        target: '_self'
    };
    return {
        href: currentTarget.href,
        target: currentTarget.target || '_self'
    };
};
module.exports["getAnchorAttributesFromEvent"] = $dc343e06d9ce05a3$export$bd1e92a09497f497;

});

parcelRegister("5UT2U", function(module, exports) {
parcelRequire("cozmU");

const $e7808faa81ca9889$export$5b1771037ab7c451 = (event)=>event.button === 1;
module.exports["isSpecialClick"] = $e7808faa81ca9889$export$5b1771037ab7c451;

});

parcelRegister("aUOXE", function(module, exports) {
parcelRequire("cozmU");


var $2r6FC = parcelRequire("2r6FC");


var $5UT2U = parcelRequire("5UT2U");


var $j06vB = parcelRequire("j06vB");

const $cb9f57a99d23cb56$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ((0, $2r6FC.isIframe)() || (0, $j06vB.isSpecialKey)(evt) || (0, $5UT2U.isSpecialClick)(evt));
module.exports["isSpecialEvent"] = $cb9f57a99d23cb56$export$efca2c4705678489;

});

parcelRegister("2r6FC", function(module, exports) {
const $a43071af5ffef504$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
module.exports["isIframe"] = $a43071af5ffef504$export$e6c5ffa684aac4d7;

});

parcelRegister("j06vB", function(module, exports) {
parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $9a41256861e5c66c$export$d8de0cd37d316fdf = (event)=>{
    return (0, $iDrrr.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
module.exports["isSpecialKey"] = $9a41256861e5c66c$export$d8de0cd37d316fdf;

});

parcelRegister("boXCt", function(module, exports) {
const $9a6f2193bc1c826f$export$9853bee72613d48f = (event, href)=>{
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;
    event.currentTarget.href = href;
};
module.exports["updateAnchorHref"] = $9a6f2193bc1c826f$export$9853bee72613d48f;

});

parcelRegister("bVAqi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");


var $iDrrr = parcelRequire("iDrrr");


var $b8pma = parcelRequire("b8pma");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $h6Vc4 = parcelRequire("h6Vc4");


var $9PA4G = parcelRequire("9PA4G");


var $lBXKn = parcelRequire("lBXKn");


var $cEvdy = parcelRequire("cEvdy");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9nA1A = parcelRequire("9nA1A");


var $8x0Rv = parcelRequire("8x0Rv");

const $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES = [
    (0, $4yYAm.SmartLinkStatus).Pending,
    (0, $4yYAm.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $dee3aec0e9ff1e8c$var$FlexibleCard = ({ appearance: appearance = 'flexible', navigation: navigation, cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url, title: ssrTitle })=>{
    const aiSummaryConfig = (0, $lBXKn.useAISummaryConfig)();
    const resolve = (0, $cEvdy.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, product: product } = (0, $bI14T.useSmartLinkContext)();
    const rovoConfig = (0, $8QLAc.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: details
    });
    const transformUrl = (0, $cozmU.useCallback)((destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl), [
        appendCrossProductAnalyticsParams,
        url
    ]);
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $cozmU.useMemo)(()=>$dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $h6Vc4.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $cozmU.useMemo)(()=>(0, $8x0Rv.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            product: product,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        onAuthorize,
        onClick,
        onAuxClick,
        onContextMenu,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        product,
        renderers,
        resolve,
        rovoConfig,
        status,
        transformUrl,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $cozmU.useMemo)(()=>({
            data: context,
            navigation: context ? navigation : undefined,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui,
        navigation
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $cozmU.useEffect)(()=>{
        switch(status){
            case (0, $4yYAm.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $4yYAm.SmartLinkStatus).Errored:
            case (0, $4yYAm.SmartLinkStatus).Fallback:
            case (0, $4yYAm.SmartLinkStatus).Forbidden:
            case (0, $4yYAm.SmartLinkStatus).NotFound:
            case (0, $4yYAm.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PA4G.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nA1A.default), {
        testId: testId,
        ...ui,
        title: ssrTitle,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $dee3aec0e9ff1e8c$export$2e2bcd8739ae039 = $dee3aec0e9ff1e8c$var$FlexibleCard;
module.exports["default"] = $dee3aec0e9ff1e8c$export$2e2bcd8739ae039;

});

parcelRegister("h6Vc4", function(module, exports) {
const $ed97ea0952c19fa7$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $ed97ea0952c19fa7$export$684541b2632ffbbc = (placeholderData)=>{
    return $ed97ea0952c19fa7$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};
module.exports["extractPlaceHolderCardState"] = $ed97ea0952c19fa7$export$684541b2632ffbbc;

});

parcelRegister("9nA1A", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $45AlW = parcelRequire("45AlW");


var $3tUjK = parcelRequire("3tUjK");


var $3A6Ej = parcelRequire("3A6Ej");


var $7ly7P = parcelRequire("7ly7P");


var $4JCld = parcelRequire("4JCld");

const $479950c88028365e$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) && (0, $45AlW.isFlexibleUiBlock)(child) ? child : undefined);
};
const $479950c88028365e$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).map((child)=>(0, $3A6Ej.getFlexibleUiBlock)(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(block)) return block.props;
};
const $479950c88028365e$var$getLayeredLink = (testId, context, children, onClick, onAuxClick, onContextMenu, title, navigation)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {}; // SSR cannot reliably extract TitleBlock props from children, so `title` is
    // provided from CardSSR as a stable server/client value to prevent hydration
    // text mismatches for the clickable container link.
    const { anchorTarget: target, text: text } = $479950c88028365e$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4JCld.default), {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        target: (0, $iDrrr.fg)('confluence_ep_shim_macro_links_v2') ? target ?? navigation?.target : target,
        testId: testId,
        text: title || text || linkTitle?.text,
        url: (0, $iDrrr.fg)('confluence_ep_shim_macro_links_v2') ? navigation?.url ?? url : url
    });
};
const $479950c88028365e$var$baseStyleCommon = null;
const $479950c88028365e$var$backgroundStyles = null;
const $479950c88028365e$var$elevationStyles = null;
const $479950c88028365e$var$clickableContainerStyles = null;
const $479950c88028365e$var$gapStyleMap = {
    xlarge: "_2mHwu8LmNS",
    large: "_2mHwu8EnCn",
    medium: "_2mHwu8dDL8",
    small: "_2mHwu8fLjz"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $479950c88028365e$var$getPadding = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $479950c88028365e$var$getGap = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $479950c88028365e$var$previewOnLeftStyleMap = {
    xlarge: "_2Zuz6QmkyU _2fNyo2NHnM",
    large: "_2Zuz6Q25OK _2fNyo2kG2W",
    medium: "_2Zuz6QGxMP _2fNyo2NTt7",
    small: "_2Zuz6Qekl6 _2fNyo22ADO"
};
const $479950c88028365e$var$previewOnRightStyleMap = {
    xlarge: "_1ZnuxbmkyU _4Fd1ZpNHnM",
    large: "_1Znuxb25OK _4Fd1ZpkG2W",
    medium: "_1ZnuxbGxMP _4Fd1ZpNTt7",
    small: "_1Znuxbekl6 _4Fd1Zp2ADO"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $479950c88028365e$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $4yYAm.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', title: title })=>{
    (0, $6cFsl.di)((0, $7ly7P.default));
    const padding = hidePadding ? '0px' : $479950c88028365e$var$getPadding(size);
    const gap = $479950c88028365e$var$getGap(size);
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    const context = cardContext?.data;
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = (0, $3tUjK.getChildrenOptions)(children, context);
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = hoverPreviewOptions?.render !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC _4bt5LAnQyn _1mT5xdRAKS _433efc7dHp _4r4FCQLl21 _20xwADLl21",
            $479950c88028365e$var$gapStyleMap[size],
            !hideBackground && "_0KLXruqi9L",
            "_4FKVYEW37H _1h1ymjW37H _2fNyo2L0ZK _4Fd1Zp5Qdv _1MQRyzr1As",
            previewOnLeft && $479950c88028365e$var$previewOnLeftStyleMap[size],
            previewOnRight && $479950c88028365e$var$previewOnRightStyleMap[size],
            !hideElevation && "_30huDKOeNX _0bjKvDyzSk _313842FQfX _0adFHsFQfX _1DCdHiFQfX _2XsHFMFQfX",
            clickableContainer && "_1zaVr2RAKS _2Y1cn1RAKS _3WoImIRAKS _4itP7C7dHp _3Xe3wl7dHp _2dGRu57dHp"
        ]),
        style: {
            "--_1xumd0e": (0, $9aYkv.default)(padding),
            "--_73mooq": (0, $9aYkv.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $9aYkv.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $479950c88028365e$var$getLayeredLink(testId, context, children, onClick, onAuxClick, onContextMenu, title, cardContext?.navigation) : null, $479950c88028365e$var$filterChildren(children, removeBlockRestriction));
    if (context?.url && canShowHoverCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ly7P.default), {
        isHoverPreview: isResolved || hasHoverCardOverride,
        isAuthTooltip: isUnresolvedWithAuthFlow,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $479950c88028365e$export$2e2bcd8739ae039 = $479950c88028365e$var$Container;
module.exports["default"] = $479950c88028365e$export$2e2bcd8739ae039;

});

parcelRegister("45AlW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9PQfP = parcelRequire("9PQfP");


var $8v3AV = parcelRequire("8v3AV");


var $3qg1D = parcelRequire("3qg1D");


var $aKJEB = parcelRequire("aKJEB");


var $l7FKw = parcelRequire("l7FKw");


var $i1503 = parcelRequire("i1503");


var $voDgt = parcelRequire("voDgt");


var $es2gJ = parcelRequire("es2gJ");


var $jdA6O = parcelRequire("jdA6O");


var $lkhb1 = parcelRequire("lkhb1");

const $080108d3272609a0$var$Blocks = {
    ActionBlock: $9PQfP.default,
    AIFooterBlock: $8v3AV.default,
    Block: $3qg1D.default,
    FooterBlock: $aKJEB.default,
    MetadataBlock: $i1503.default,
    PreviewBlock: $voDgt.default,
    SnippetBlock: $es2gJ.default,
    TitleBlock: $jdA6O.default,
    ResolvedHoverCardFooterBlock: $l7FKw.default
};
const $080108d3272609a0$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if ((0, $lkhb1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $080108d3272609a0$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($080108d3272609a0$var$Blocks).some((type)=>type === node.type)) return true;
    return false;
};
module.exports["isFlexibleUiBlock"] = $080108d3272609a0$export$b56fc89cf6e7d1e9;

});

parcelRegister("9PQfP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $it2N0 = parcelRequire("it2N0");


var $cOVCp = parcelRequire("cOVCp");


var $5Nciw = parcelRequire("5Nciw");


var $5IFQc = parcelRequire("5IFQc");


var $1FScK = parcelRequire("1FScK");


var $bHsBU = parcelRequire("bHsBU");


var $fhinp = parcelRequire("fhinp");


var $kD7T6 = parcelRequire("kD7T6");


var $78OZj = parcelRequire("78OZj");


var $1fKLY = parcelRequire("1fKLY");


var $e8Ej5 = parcelRequire("e8Ej5");


var $kI1Tj = parcelRequire("kI1Tj");


var $cpdvP = parcelRequire("cpdvP");


var $76b0u = parcelRequire("76b0u");


var $4jh4U = parcelRequire("4jh4U");

const $733a7410919e6a84$var$ignoreContainerPaddingStyles = null;
const $733a7410919e6a84$var$Actions = {
    [(0, $4yYAm.ActionName).AutomationAction]: (0, $5IFQc.default),
    [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $1FScK.default),
    [(0, $4yYAm.ActionName).CustomAction]: (0, $cOVCp.default),
    [(0, $4yYAm.ActionName).DeleteAction]: (0, $fhinp.default),
    [(0, $4yYAm.ActionName).DownloadAction]: (0, $kD7T6.default),
    [(0, $4yYAm.ActionName).EditAction]: (0, $78OZj.default),
    [(0, $4yYAm.ActionName).FollowAction]: (0, $1fKLY.default),
    [(0, $4yYAm.ActionName).PreviewAction]: (0, $e8Ej5.default),
    [(0, $4yYAm.ActionName).RovoChatAction]: (0, $kI1Tj.default),
    [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $5Nciw.default),
    [(0, $4yYAm.InternalActionName).UnresolvedAction]: (0, $bHsBU.default),
    [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $cpdvP.default)
};
const $733a7410919e6a84$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $733a7410919e6a84$var$sort = (a, b)=>{
    let idxA = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $733a7410919e6a84$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $6cFsl.di)((0, $76b0u.ActionFooter));
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const onLoadingChange = (0, $cozmU.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $4jh4U.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $4yYAm.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $cozmU.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $cozmU.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions).filter((name)=>name !== (0, $4yYAm.ActionName).RovoChatAction);
        arr.sort($733a7410919e6a84$var$sort);
        const renderAction = (name)=>{
            const Action = name in $733a7410919e6a84$var$Actions ? $733a7410919e6a84$var$Actions[name] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $cozmU.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                style: padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name)=>renderAction(name));
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    if (!actions) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _2O5Vij7dHp _39xV02yJ9Z _2XsHFMynja _0adFHsdEJg",
            className
        ])
    }, actions, /*#__PURE__*/ $cozmU.createElement((0, $76b0u.ActionFooter), {
        message: message,
        testId: testId
    }));
};
var $733a7410919e6a84$export$2e2bcd8739ae039 = $733a7410919e6a84$var$ActionBlock;
module.exports["default"] = $733a7410919e6a84$export$2e2bcd8739ae039;

});

parcelRegister("76b0u", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $oYjIk = parcelRequire("oYjIk");

const $21a638afd8e71cc8$var$styles = {
    containerStyles: "_1mb4UnZqHV _0bjKvDKxmn _4c065UgVvo _2Y7lL42ADO _3138422ADO _0adFHs2ADO _1DCdHiPgdg _2XsHFM2ADO _39xV02N91d _11sDorYbGa",
    errorContentStyles: "_0LQT5EFQfX",
    titleStyles: "_2sNsIg7NXe _1UtDYzZpcK"
};
const $21a638afd8e71cc8$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $21a638afd8e71cc8$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $21a638afd8e71cc8$var$styles.containerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $21a638afd8e71cc8$var$styles.errorContentStyles
    }, message.icon || $21a638afd8e71cc8$var$getIcon(message.appearance), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $21a638afd8e71cc8$var$styles.titleStyles
    }, message.title))));
};
module.exports["ActionFooter"] = $21a638afd8e71cc8$export$2d2b754ac238f9aa;

});

parcelRegister("oYjIk", function(module, exports) {
$parcel$export(module.exports, "default", () => $83fb3cab53de2f1c$export$2e2bcd8739ae039);

var $dAvfG = parcelRequire("dAvfG");

var $83fb3cab53de2f1c$export$2e2bcd8739ae039 = (0, $dAvfG.MotionWrapper);

});

parcelRegister("dAvfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $ce2c060463892fde$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const ref = (0, $cozmU.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $cozmU.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
module.exports["MotionWrapper"] = $ce2c060463892fde$export$6118ed0013927eb2;

});

parcelRegister("4jh4U", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4yYAm = parcelRequire("4yYAm");

const $b487ec544451b717$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
module.exports["getPrimitivesPaddingSpaceBySize"] = $b487ec544451b717$export$1af10e3728e3a644;

});

parcelRegister("8v3AV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $49d2i = parcelRequire("49d2i");

/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $7846684e20fcf82a$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $49d2i.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $7846684e20fcf82a$export$2e2bcd8739ae039 = $7846684e20fcf82a$var$AIFooterBlock;
module.exports["default"] = $7846684e20fcf82a$export$2e2bcd8739ae039;

});

parcelRegister("49d2i", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $fCf6x = parcelRequire("fCf6x");


var $3qg1D = parcelRequire("3qg1D");


var $G1hgp = parcelRequire("G1hgp");

const $7c294d42de00b7e6$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $G1hgp.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $7c294d42de00b7e6$export$2e2bcd8739ae039 = $7c294d42de00b7e6$var$AIFooterBlockResolvedView;
module.exports["default"] = $7c294d42de00b7e6$export$2e2bcd8739ae039;

});

parcelRegister("G1hgp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $gC0KQ = parcelRequire("gC0KQ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $dM7c5 = parcelRequire("dM7c5");


var $euBHF = parcelRequire("euBHF");


var $5lPjI = parcelRequire("5lPjI");

const $880107268f4b308a$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { state: { status: status } } = (0, $euBHF.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lPjI.InfoIcon), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};
module.exports["AIFooterMetadata"] = $880107268f4b308a$export$175228cc2c92b3b6;

});

parcelRegister("5lPjI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fodiz = parcelRequire("fodiz");

const $fb266bb3a6e3891f$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: props.color || 'currentColor',
        ...props
    });
module.exports["InfoIcon"] = $fb266bb3a6e3891f$export$2957fc44b3d2481;

});

parcelRegister("aKJEB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a36bd3253a439cd$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $1ynAu = parcelRequire("1ynAu");

var $8a36bd3253a439cd$export$2e2bcd8739ae039 = (0, $1ynAu.FooterBlock);

});

parcelRegister("1ynAu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $hSS22 = parcelRequire("hSS22");

const $3bd7862020a24ed3$export$f83744e65a5b0c8f = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSS22.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
module.exports["FooterBlock"] = $3bd7862020a24ed3$export$f83744e65a5b0c8f;

});

parcelRegister("hSS22", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a3Cph = parcelRequire("a3Cph");


var $1LXnB = parcelRequire("1LXnB");


var $4yYAm = parcelRequire("4yYAm");


var $kjaz0 = parcelRequire("kjaz0");


var $fCf6x = parcelRequire("fCf6x");


var $3M4EV = parcelRequire("3M4EV");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");


var $lOv7Z = parcelRequire("lOv7Z");

const $5fa216af8f5b31f0$var$actionGroupStyles = null;
const $5fa216af8f5b31f0$var$safariStyles = null;
const $5fa216af8f5b31f0$var$providerStyles = null;
const $5fa216af8f5b31f0$var$rovoActionStyles = null;
const $5fa216af8f5b31f0$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $4yYAm.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const rovoChatAction = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $cozmU.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && actions?.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        actions
    ]);
    const hasPreview = isRovoActionsEnabled && !!context?.preview && !isPreviewBlockErrored;
    const hasActions = (0, $cozmU.useMemo)(()=>(0, $lOv7Z.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    const onDropdownOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]); // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $cozmU.useState)(undefined);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $cozmU.createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $hekY6.default)([
            isRovoActionsEnabled && "_4xdlr0DIqT"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        testId: "smart-element-group-actions",
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        className: (0, $hekY6.default)([
            size === (0, $4yYAm.SmartLinkSize).XLarge && "_0NUa3rVa5s",
            safari && "_0jFU0VN91d",
            isRovoActionsEnabled && "_1mT5xdRAKS"
        ])
    }, !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' && /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: isRovoActionsEnabled ? 'subtle' : 'default',
        size: isRovoActionsEnabled ? (0, $4yYAm.SmartLinkSize).Small : size,
        containerWidth: isRovoActionsEnabled ? containerWidth : undefined
    })) : null);
};
var $5fa216af8f5b31f0$export$2e2bcd8739ae039 = $5fa216af8f5b31f0$var$FooterBlockResolvedView;
module.exports["default"] = $5fa216af8f5b31f0$export$2e2bcd8739ae039;

});

parcelRegister("l7FKw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $kjaz0 = parcelRequire("kjaz0");


var $5Nciw = parcelRequire("5Nciw");


var $5IFQc = parcelRequire("5IFQc");


var $1FScK = parcelRequire("1FScK");


var $bHsBU = parcelRequire("bHsBU");


var $kD7T6 = parcelRequire("kD7T6");


var $1fKLY = parcelRequire("1fKLY");


var $e8Ej5 = parcelRequire("e8Ej5");


var $kI1Tj = parcelRequire("kI1Tj");


var $cpdvP = parcelRequire("cpdvP");


var $fCf6x = parcelRequire("fCf6x");


var $3qg1D = parcelRequire("3qg1D");

const $dffaffb44f533d82$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $4yYAm.ActionName).RovoChatAction
];
const $dffaffb44f533d82$var$Actions = {
    [(0, $4yYAm.ActionName).AutomationAction]: (0, $5IFQc.default),
    [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $1FScK.default),
    [(0, $4yYAm.ActionName).DownloadAction]: (0, $kD7T6.default),
    [(0, $4yYAm.ActionName).FollowAction]: (0, $1fKLY.default),
    [(0, $4yYAm.ActionName).PreviewAction]: (0, $e8Ej5.default),
    [(0, $4yYAm.ActionName).RovoChatAction]: (0, $kI1Tj.default),
    [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $5Nciw.default),
    [(0, $4yYAm.InternalActionName).UnresolvedAction]: (0, $bHsBU.default),
    [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $cpdvP.default)
};
const $dffaffb44f533d82$var$ignoreContainerMarginStyles = null;
const $dffaffb44f533d82$var$elevatedFooterStyles = null;
const $dffaffb44f533d82$var$providerStyles = null;
const $dffaffb44f533d82$var$actionsStyles = null; /**
                             * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
                             * @internal
                             * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
                             * @see Block
                             */ 
const $dffaffb44f533d82$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const size = props.size ?? cardContext?.ui?.size;
    const actions = (0, $cozmU.useMemo)(()=>{
        if (!context?.actions) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$dffaffb44f533d82$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name)=>{
            const Action = name in $dffaffb44f533d82$var$Actions ? $dffaffb44f533d82$var$Actions[name] : undefined; // Note: For the spinner to render properly, e.g. AI summary action,
            // the spinner need to be updated. See FIX-ME comment on ActionButton
            return Action ? /*#__PURE__*/ $cozmU.createElement(Action, {
                key: name,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick?.(name),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context?.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $hekY6.default)([
            "_2Y7lL45zaO _4c065U8HPE _24h04i2Njc _39xV02yJ9Z _2XsHFMynja _0adFHsdEJg _1DCdHiBZ2D _0jFU0Vp0Oa",
            "_2mHwu82ADO _2bqfgdNCjk _0KLXrunmFW _1v9SsV8fU6 _3XDz3B8fU6"
        ])
    }, !hideProvider && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VNHnM _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _24h04i2Njc _2O5Vij7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $hekY6.default)([
            "_2mHwu8dnbC _3iDTPbQ4SZ _2XsHFMIZbP _0hPCNLDIqT _24h04i2Njc _0t0I5tPgdg _4zSe6cKxmn _2TZM8zPgdg _3106lDPgdg _0sAz8XPgdg _10thuuPgdg _1Q7lGrPgdg _20mOCkPgdg _2l7X6vPgdg _2oM2ZOPgdg _0rQkwDPgdg _0ej2VWPgdg"
        ])
    }, actions) : null);
};
var $dffaffb44f533d82$export$2e2bcd8739ae039 = $dffaffb44f533d82$var$ResolvedHoverCardFooterBlock;
module.exports["default"] = $dffaffb44f533d82$export$2e2bcd8739ae039;

});

parcelRegister("voDgt", function(module, exports) {
$parcel$export(module.exports, "default", () => $573950a3d3f757c4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("ePDLf")).PreviewBlock);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $ePDLf = parcelRequire("ePDLf");

var $573950a3d3f757c4$export$2e2bcd8739ae039 = (0, $ePDLf.PreviewBlock);

});

parcelRegister("ePDLf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $it2N0 = parcelRequire("it2N0");


var $ecoFR = parcelRequire("ecoFR");

const $47e9c4618f0b8ba5$export$fff1c9c894fd3e9c = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $it2N0.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ecoFR.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
module.exports["PreviewBlock"] = $47e9c4618f0b8ba5$export$fff1c9c894fd3e9c;

});

parcelRegister("ecoFR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $khRQO = parcelRequire("khRQO");


var $3qg1D = parcelRequire("3qg1D");

const $162c9c59097b1dcb$var$previewBlockStyleCommon = null;
const $162c9c59097b1dcb$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $162c9c59097b1dcb$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)(style ?? {});
    const updateStyles = (0, $cozmU.useCallback)(()=>{
        if (placement === (0, $4yYAm.MediaPlacement).Left || placement === (0, $4yYAm.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $4yYAm.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $4yYAm.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]); // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $cozmU.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $cozmU.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $cozmU.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $hekY6.default)([
            placement && "_4iezaCZqHV _2kPTywZqHV _2ou5bLN91d _1OK2ToN91d _1v5VxwiObl",
            !placement && ignoreContainerPadding && "_2XsHFMynja _0adFHsdEJg _0VmJBdBZ2D _0TKI3dBZ2D",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $khRQO.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $162c9c59097b1dcb$export$2e2bcd8739ae039 = $162c9c59097b1dcb$var$PreviewBlockResolvedView;
module.exports["default"] = $162c9c59097b1dcb$export$2e2bcd8739ae039;

});

parcelRegister("es2gJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a551202d4fb14617$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("gM5Xj")).SnippetBlock);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $gM5Xj = parcelRequire("gM5Xj");

var $a551202d4fb14617$export$2e2bcd8739ae039 = (0, $gM5Xj.SnippetBlock);

});

parcelRegister("gM5Xj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $kjaz0 = parcelRequire("kjaz0");


var $it2N0 = parcelRequire("it2N0");


var $9ojsk = parcelRequire("9ojsk");


var $s4fzU = parcelRequire("s4fzU");


var $dXXGF = parcelRequire("dXXGF");


var $3qg1D = parcelRequire("3qg1D");


var $3fa84 = parcelRequire("3fa84");

const $0fc7acbe682d9571$export$ababd1478ac17bc0 = ({ maxLines: maxLines = (0, $3fa84.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $it2N0.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $dXXGF.getMaxLines)(maxLines, (0, $3fa84.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, (0, $3fa84.SNIPPET_BLOCK_CONSTANTS).MAXIMUM_MAX_LINES, (0, $3fa84.SNIPPET_BLOCK_CONSTANTS).MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $s4fzU.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, snippet);
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SnippetReplacement, {
        fallbackText: (text || context?.snippet) ?? '',
        fallbackComponent: snippet,
        contentId: context?.meta?.objectId ?? '',
        contentType: context?.meta?.resourceType ?? '',
        cloudId: context?.meta?.tenantId ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};
module.exports["SnippetBlock"] = $0fc7acbe682d9571$export$ababd1478ac17bc0;

});

parcelRegister("dXXGF", function(module, exports) {
const $6bd8eb164b02c49b$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
module.exports["getMaxLines"] = $6bd8eb164b02c49b$export$c2293adf1794c09;

});

parcelRegister("3fa84", function(module, exports) {
const $702a70cca13790b5$export$ca3749285a470843 = {
    DEFAULT_MAX_LINES: 3,
    MAXIMUM_MAX_LINES: 6,
    MINIMUM_MAX_LINES: 1
};
module.exports["SNIPPET_BLOCK_CONSTANTS"] = $702a70cca13790b5$export$ca3749285a470843;

});

parcelRegister("3tUjK", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $1CN4f = parcelRequire("1CN4f");


var $cRa1x = parcelRequire("cRa1x");

const $f4708050f839cf5f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $1CN4f.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
            if ((0, $cRa1x.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $4yYAm.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $4yYAm.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
module.exports["getChildrenOptions"] = $f4708050f839cf5f$export$6f4e0540a2f2295a;

});

parcelRegister("1CN4f", function(module, exports) {
const $b11c19fc9aa89c7e$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);
module.exports["isFlexUiPreviewPresent"] = $b11c19fc9aa89c7e$export$783c1bf8fee63f80;

});

parcelRegister("cRa1x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $voDgt = parcelRequire("voDgt");


var $lkhb1 = parcelRequire("lkhb1");

const $f2d6ed6c9c61975a$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (node.type === (0, $voDgt.default)) return true;
    if ((0, $lkhb1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f2d6ed6c9c61975a$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
module.exports["isFlexibleUiPreviewBlock"] = $f2d6ed6c9c61975a$export$c0547b4405cae584;

});

parcelRegister("3A6Ej", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lkhb1 = parcelRequire("lkhb1");


var $jdA6O = parcelRequire("jdA6O");

const $ae8ca2bb9643e905$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return undefined;
    if (node.type === (0, $jdA6O.default)) return node;
    if ((0, $lkhb1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ae8ca2bb9643e905$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
module.exports["getFlexibleUiBlock"] = $ae8ca2bb9643e905$export$f6c7a950371733c8;

});

parcelRegister("7ly7P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $iDPVo = parcelRequire("iDPVo");


var $jLxvy = parcelRequire("jLxvy");

const $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $32ab5c854e7cdaa4$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $cozmU.useState)(true);
    const mouseStopTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $cozmU.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $4yYAm.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onBlur: (0, $iDPVo.noop),
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $32ab5c854e7cdaa4$export$2e2bcd8739ae039 = $32ab5c854e7cdaa4$var$HoverCardControl;
module.exports["default"] = $32ab5c854e7cdaa4$export$2e2bcd8739ae039;

});

parcelRegister("iDPVo", function(module, exports) {
const $243db100139a8985$export$8793edee2d425525 = ()=>undefined;
module.exports["noop"] = $243db100139a8985$export$8793edee2d425525;

});

parcelRegister("jLxvy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $lzgC6 = parcelRequire("lzgC6");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $12fG9 = parcelRequire("12fG9");


var $kSkO7 = parcelRequire("kSkO7");


var $4TMNS = parcelRequire("4TMNS");


var $1dET2 = parcelRequire("1dET2");


var $cn7Ll = parcelRequire("cn7Ll");

const $f35adce8a13b91c6$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $6cFsl.di)((0, $cn7Ll.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $1dET2.useSmartLinkAnalyticsContext)({
        display: (0, $4yYAm.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $cn7Ll.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $cozmU.useCallback)((error, info)=>{
        (0, $kSkO7.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $12fG9.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $12fG9.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4TMNS.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cn7Ll.HoverCardComponent), props, children)));
};
const $f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext = (0, $lzgC6.default)()($f35adce8a13b91c6$var$HoverCardWithErrorBoundary);
const $f35adce8a13b91c6$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext, props);
};
module.exports["HoverCard"] = $f35adce8a13b91c6$export$57a077cc9fbe653e;

});

parcelRegister("cn7Ll", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $4yYAm = parcelRequire("4yYAm");


var $iUTeb = parcelRequire("iUTeb");


var $9ojsk = parcelRequire("9ojsk");


var $9H66G = parcelRequire("9H66G");


var $1smAh = parcelRequire("1smAh");


var $iDPVo = parcelRequire("iDPVo");


var $4xm0k = parcelRequire("4xm0k");


var $7CAOU = parcelRequire("7CAOU");


var $9YjhY = parcelRequire("9YjhY");

const $73aa8936eb4c3aa9$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $73aa8936eb4c3aa9$var$FADE_IN_DELAY = 500;
const $73aa8936eb4c3aa9$var$FADE_OUT_DELAY = 300;
const $73aa8936eb4c3aa9$var$RESOLVE_DELAY = 100;
const $73aa8936eb4c3aa9$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $7CAOU.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, placement: placement, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $73aa8936eb4c3aa9$var$FADE_IN_DELAY;
    const gatedPlacement = placement && (0, $2pQiO.UNSAFE_expValNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', false) ? placement : undefined;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const fadeOutTimeoutId = (0, $cozmU.useRef)();
    const fadeInTimeoutId = (0, $cozmU.useRef)();
    const resolveTimeOutId = (0, $cozmU.useRef)();
    const mousePos = (0, $cozmU.useRef)();
    const popupOffset = (0, $cozmU.useRef)();
    const parentSpan = (0, $cozmU.useRef)(null);
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $iUTeb.useSmartCardActions)(id, url);
    const setMousePosition = (0, $cozmU.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        // A caller-chosen placement anchors the card to the trigger, so a cursor-relative offset
        // would drag it back over the element the placement was picked to keep clear of.
        if (gatedPlacement) return;
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $7CAOU.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $7CAOU.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen,
        gatedPlacement
    ]);
    const hideCard = (0, $cozmU.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $cozmU.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $73aa8936eb4c3aa9$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $cozmU.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $cozmU.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus || linkState.status === 'resolved' && linkState.metadataStatus === 'pending' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
            register();
            else // Link has been already been partially resolved. Load metadata.
            loadMetadata();
        }, $73aa8936eb4c3aa9$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $cozmU.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $cozmU.useCallback)((actionId)=>{
        if (actionId === (0, $4yYAm.ActionName).PreviewAction || actionId === (0, $4yYAm.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $cozmU.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $cozmU.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onDismiss: hideCard,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id,
            source: $73aa8936eb4c3aa9$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4xm0k.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        hideCard,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            initShowCard(e);
        }
    }, [
        initShowCard
    ]);
    const trigger = (0, $cozmU.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, // `aria-controls` is also stripped because the trigger wrapper renders
    // with `role="none"`. axe's `aria-valid-attr-value` rule flags any
    // `aria-controls` value sitting on a presentational element, since the
    // element has no semantic role to control. Removing the attribute
    // keeps the trigger semantically inert without losing functionality.
    'aria-controls': _ariaControls, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onKeyDown: handleKeyDown,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER,
            onFocus: (0, $iDPVo.noop),
            onBlur: (0, $iDPVo.noop),
            role: "none"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        handleKeyDown
    ]);
    const popupComponent = (0, $cozmU.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $9YjhY.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: initHideCard,
        placement: gatedPlacement ?? 'bottom-start',
        // A trigger-anchored card keeps the same gap the cursor-anchored one leaves.
        offset: gatedPlacement ? [
            0,
            (0, $7CAOU.CARD_GAP_PX)
        ] : popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        popupComponent: popupComponent
    });
};
module.exports["HOVER_CARD_SOURCE"] = $73aa8936eb4c3aa9$export$421dbc3834daf261;
module.exports["HoverCardComponent"] = $73aa8936eb4c3aa9$export$e2173dafa6a751bb;

});

parcelRegister("4xm0k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $9DHhW = parcelRequire("9DHhW");


var $bI14T = parcelRequire("bI14T");


var $8m50u = parcelRequire("8m50u");


var $c3xon = parcelRequire("c3xon");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $2xwXF = parcelRequire("2xwXF");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $dIcCR = parcelRequire("dIcCR");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");


var $pRou6 = parcelRequire("pRou6");


var $izOnk = parcelRequire("izOnk");


var $gD4nS = parcelRequire("gD4nS");


var $aUOXE = parcelRequire("aUOXE");


var $boXCt = parcelRequire("boXCt");


var $7CAOU = parcelRequire("7CAOU");


var $6nncv = parcelRequire("6nncv");


var $6GUs4 = parcelRequire("6GUs4");


var $93zgq = parcelRequire("93zgq");


var $dcCaJ = parcelRequire("dcCaJ");


var $exTWI = parcelRequire("exTWI");


var $apqge = parcelRequire("apqge");


var $8qkhz = parcelRequire("8qkhz");

const $51fe488ad53df981$export$34883cbaea18402d = 'smart-links-hover-preview';
const $51fe488ad53df981$var$useIsResolvedView = ({ cardState: cardState, hoverPreviewOptions: hoverPreviewOptions })=>{
    return !hoverPreviewOptions?.render?.() && cardState.status === 'resolved';
};
const $51fe488ad53df981$var$useServices = ({ url: url })=>{
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const services = (0, $dIcCR.getServices)(linkState.details);
    return services;
};
const $51fe488ad53df981$var$useIsUnauthorisedView = ({ cardState: cardState, url: url, hoverPreviewOptions: hoverPreviewOptions })=>{
    const services = $51fe488ad53df981$var$useServices({
        url: url
    });
    return !hoverPreviewOptions?.render?.() && cardState.status === 'unauthorized' && Boolean(services?.length);
};
const $51fe488ad53df981$var$useIsShowPreauthBetterHovercard = (props)=>{
    const { rovoOptions: rovoConfig } = (0, $8QLAc.default)();
    return Boolean($51fe488ad53df981$var$useIsUnauthorisedView(props) && rovoConfig?.isRovoEnabled && (0, $ieeJu.expValEquals)('platform_sl_3p_preauth_better_hovercard', 'isEnabled', true));
};
const $51fe488ad53df981$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDismiss: onDismiss, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const extensionKey = (0, $cozmU.useMemo)(()=>(0, $fXZFy.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $cozmU.useMemo)(()=>(0, $h5RL7.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $bI14T.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $gD4nS.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $dIcCR.getServices)(linkState.details);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    const statusRef = (0, $cozmU.useRef)(linkStatus);
    const fireEventRef = (0, $cozmU.useRef)(fireEvent);
    const definitionIdRef = (0, $cozmU.useRef)(definitionId);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Must access object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const getDestinationUrl = (0, $cozmU.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $2xwXF.getClickUrl)(url, linkState.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        linkState.details,
        url
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onAuxClick = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $boXCt.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onContextMenu = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $boXCt.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    const onClick = (0, $cozmU.useCallback)((event)=>{
        // Prevent the anchor's native navigation so we can open the destination URL
        // with cross-product analytics query parameters appended.
        // The cross-product params are client-only and cannot be rendered
        // server-side. Falls back to the original `url` prop if the event target is
        // not an anchor element.
        event.preventDefault();
        const { target: target } = (0, $izOnk.getAnchorAttributesFromEvent)(event);
        const destinationUrl = getDestinationUrl();
        (0, $boXCt.updateAnchorHref)(event, destinationUrl);
        window.open(destinationUrl, target);
        const isModifierKeyPressed = (0, $aUOXE.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $pRou6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        getDestinationUrl,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $6nncv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $4yYAm.SmartLinkSize).Large,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        subtitle: subtitle,
        anchorTarget: product === 'ATLAS' ? '_self' : undefined
    };
    const uiOptions = (0, $7CAOU.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $4yYAm.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $cozmU.useCallback)((e)=>e.stopPropagation(), []);
    const useIsResolvedViewGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsResolvedView, ()=>undefined);
    const useIsUnauthorisedViewGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsUnauthorisedView, ()=>undefined);
    const useIsShowPreauthBetterHovercardGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsShowPreauthBetterHovercard, ()=>undefined);
    const isResolved = useIsResolvedViewGated({
        cardState: cardState,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const isUnauthorised = useIsUnauthorisedViewGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const showPreauthBetterHovercard = useIsShowPreauthBetterHovercardGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    if ((0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch')) {
        const cardView = (()=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (isUnauthorised) {
                if (showPreauthBetterHovercard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8qkhz.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    onDismiss: onDismiss,
                    url: url
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    url: url
                });
            }
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (isResolved) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        })();
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            widthAppearance: showPreauthBetterHovercard ? 'slim' : undefined,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    } else {
        const getCardView = (cardState)=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    }
};
const $51fe488ad53df981$var$HoverCardContentWithViewVariant = (props)=>{
    const showPreauthBetterHovercard = $51fe488ad53df981$var$useIsShowPreauthBetterHovercard(props);
    const data = (0, $cozmU.useMemo)(()=>{
        let viewVariant = 'default';
        if (showPreauthBetterHovercard) viewVariant = 'rovo-unauthorised-view';
        return {
            attributes: {
                viewVariant: viewVariant
            }
        };
    }, [
        showPreauthBetterHovercard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51fe488ad53df981$var$HoverCardContent, props));
};
const $51fe488ad53df981$var$_default_1 = (0, $8m50u.componentWithCondition)(()=>{
    return (0, $iDrrr.fg)('platform_sl_3p_preauth_better_hovercard_killswitch');
}, $51fe488ad53df981$var$HoverCardContentWithViewVariant, $51fe488ad53df981$var$HoverCardContent);
var $51fe488ad53df981$export$2e2bcd8739ae039 = $51fe488ad53df981$var$_default_1;
module.exports["hoverCardClassName"] = $51fe488ad53df981$export$34883cbaea18402d;
module.exports["default"] = $51fe488ad53df981$export$2e2bcd8739ae039;

});

parcelRegister("gD4nS", function(module, exports) {
const $b6837e8ecd1b21f2$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
module.exports["getIsAISummaryEnabled"] = $b6837e8ecd1b21f2$export$d439c74cb206ff29;

});

parcelRegister("7CAOU", function(module, exports) {

var $jp2Q3 = parcelRequire("jp2Q3");


var $4yYAm = parcelRequire("4yYAm");

const $4b92af562a9f6a65$export$8245b0eaabf3440c = (0, $jp2Q3.layers).modal();
const $4b92af562a9f6a65$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    zIndex: $4b92af562a9f6a65$export$8245b0eaabf3440c + 1
};
const $4b92af562a9f6a65$export$a0a37c997fbcd678 = 24;
const $4b92af562a9f6a65$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card
module.exports["HOVER_CARD_Z_INDEX"] = $4b92af562a9f6a65$export$8245b0eaabf3440c;
module.exports["flexibleUiOptions"] = $4b92af562a9f6a65$export$8e022b7269e8199a;
module.exports["CARD_WIDTH_REM"] = $4b92af562a9f6a65$export$a0a37c997fbcd678;
module.exports["CARD_GAP_PX"] = $4b92af562a9f6a65$export$e7cae8c75d768024;

});

parcelRegister("6nncv", function(module, exports) {

var $4FdKz = parcelRequire("4FdKz");


var $4yYAm = parcelRequire("4yYAm");


var $7Nudn = parcelRequire("7Nudn");

const $40b39971c7d4e97d$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $4FdKz.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $4yYAm.ElementName).AuthorGroup,
            (0, $4yYAm.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).SubscriberCount,
                    (0, $4yYAm.ElementName).State
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).SourceBranch,
                    (0, $4yYAm.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $4yYAm.ElementName).LatestCommit,
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $7Nudn.extractOwnedBy)(data) ? (0, $4yYAm.ElementName).OwnedByGroup : (0, $4yYAm.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $4yYAm.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $4yYAm.ElementName).AssignedToGroup,
                        (0, $4yYAm.ElementName).State,
                        (0, $4yYAm.ElementName).StoryPoints,
                        (0, $4yYAm.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ],
                secondary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).AttachmentCount,
                    (0, $4yYAm.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).SentOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix = [
    (0, $4yYAm.ElementName).AssignedToGroup,
    (0, $4yYAm.ElementName).OwnedByGroup,
    (0, $4yYAm.ElementName).AuthorGroup
];
const $40b39971c7d4e97d$var$toElementItem = (name)=>{
    const showNamePrefix = $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $40b39971c7d4e97d$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $4yYAm.ElementName)).map($40b39971c7d4e97d$var$toElementItem);
};
const $40b39971c7d4e97d$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $40b39971c7d4e97d$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $40b39971c7d4e97d$var$toElementItems(metadata.subtitle),
        primary: $40b39971c7d4e97d$var$toElementItems(primary),
        secondary: $40b39971c7d4e97d$var$toElementItems(metadata.secondary)
    };
};
module.exports["getMetadata"] = $40b39971c7d4e97d$export$8548546c0aa631e6;

});

parcelRegister("7Nudn", function(module, exports) {

var $7LPcf = parcelRequire("7LPcf");

const $70e3a6e170c5c845$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $7LPcf.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
module.exports["extractOwnedBy"] = $70e3a6e170c5c845$export$75b4b5a156f48ff3;

});

parcelRegister("6GUs4", function(module, exports) {
/* ContentContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $euBHF = parcelRequire("euBHF");


var $6PgB0 = parcelRequire("6PgB0");


var $4xm0k = parcelRequire("4xm0k");

const $d306b041e75683ad$var$HoverCardContainerStyle = null;
const $d306b041e75683ad$var$hoverCardShellWidthDefault = null;
const $d306b041e75683ad$var$hoverCardShellWidthSlim = null;
const $d306b041e75683ad$var$hoverCardShellHideLoadingPlaceholder = null;
const $d306b041e75683ad$var$popupContainerStyles = null;
const $d306b041e75683ad$var$ConnectedAIPrismContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $6PgB0.default));
    const { state: { status: status } } = (0, $euBHF.default)(url);
    const [showPrism, setShowPrism] = (0, $cozmU.useState)(status === 'loading');
    (0, $cozmU.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const resolvedWidthAppearance = widthAppearance ?? 'default';
    const container = /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _2V7sgOdnbC _24h04i2Njc",
            resolvedWidthAppearance === 'slim' ? "_39xV02zZoh" : "_39xV02VTmU",
            "_0E5LJLYbGa",
            !isAIEnabled && "_0bjKvD8fU6 _0KLXruoI2d _2OUyjtGk8v",
            (0, $4xm0k.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $6PgB0.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $d306b041e75683ad$var$ContentContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $cozmU.createElement($d306b041e75683ad$var$ConnectedAIPrismContainer, {
        widthAppearance: widthAppearance,
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $d306b041e75683ad$export$2e2bcd8739ae039 = $d306b041e75683ad$var$ContentContainer;
module.exports["default"] = $d306b041e75683ad$export$2e2bcd8739ae039;

});

parcelRegister("93zgq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $hHrlI = parcelRequire("hHrlI");


var $leSBv = parcelRequire("leSBv");


var $gCfXH = parcelRequire("gCfXH");


var $dM7c5 = parcelRequire("dM7c5");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");


var $voDgt = parcelRequire("voDgt");

const $950782f89926949b$var$titleBlockStyles = null;
const $950782f89926949b$var$mainTextStyles = null;
const $950782f89926949b$var$connectButtonStyles = null;
const $950782f89926949b$var$basePreviewStyles = null;
const $950782f89926949b$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ $cozmU.createElement("b", null, (0, $gCfXH.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $leSBv.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $hekY6.default)([
            "_2C2kUQ8fU6 _1Lz9lo8fU6 _1DCdHi2ADO"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_37wbyuDIqT _1kk5Tk7GSX _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbS8kF _37wbyuDIqT _313842Pgdg _2fwxA5DIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        className: (0, $hekY6.default)([
            "_37wbyuDIqT _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $950782f89926949b$export$2e2bcd8739ae039 = $950782f89926949b$var$HoverCardForbiddenView;
module.exports["default"] = $950782f89926949b$export$2e2bcd8739ae039;

});

parcelRegister("leSBv", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");


var $6GOAK = parcelRequire("6GOAK");


var $9ug60 = parcelRequire("9ug60");


var $gCfXH = parcelRequire("gCfXH");

const $ee3dc381f0d57dc0$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $gCfXH.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $dM7c5.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $dM7c5.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $9ug60.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $dM7c5.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $dM7c5.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};
module.exports["extractRequestAccessContextImproved"] = $ee3dc381f0d57dc0$export$846c1540a86749e6;

});

parcelRegister("9ug60", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dM7c5 = parcelRequire("dM7c5");

const $053e2873bd8bd139$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $dM7c5.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });
module.exports["ForbiddenAction"] = $053e2873bd8bd139$export$59f8830fb5467e35;

});

parcelRegister("gCfXH", function(module, exports) {
const $dd8187e5dc61e444$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $dd8187e5dc61e444$export$2e2bcd8739ae039 = $dd8187e5dc61e444$var$extractHostname;
module.exports["default"] = $dd8187e5dc61e444$export$2e2bcd8739ae039;

});

parcelRegister("dcCaJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $ahcye = parcelRequire("ahcye");


var $euBHF = parcelRequire("euBHF");


var $bVAqi = parcelRequire("bVAqi");


var $9PQfP = parcelRequire("9PQfP");


var $8v3AV = parcelRequire("8v3AV");


var $i9PP7 = parcelRequire("i9PP7");


var $i1503 = parcelRequire("i1503");


var $es2gJ = parcelRequire("es2gJ");


var $jdA6O = parcelRequire("jdA6O");


var $6nncv = parcelRequire("6nncv");


var $9BEAr = parcelRequire("9BEAr");

const $9a8a2863bdf59a4a$var$hiddenSnippetStyles = null;
const $9a8a2863bdf59a4a$var$titleBlockStyles = null;
const $9a8a2863bdf59a4a$var$snippetBlockCss = null;
const $9a8a2863bdf59a4a$var$actionBlockCss = null;
const $9a8a2863bdf59a4a$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $ahcye.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $ahcye.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $cozmU.useMemo)(()=>{
        return (0, $6nncv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(0);
    const snippetBlockRef = (0, $cozmU.useRef)(null);
    const onSnippetRender = (0, $cozmU.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $9BEAr.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        className: (0, $hekY6.default)([
            "_0Of8r21Y8M"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVAqi.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        ...titleBlockProps,
        metadataPosition: (0, $4yYAm.SmartLinkPosition).Top,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _1LQKoXPgdg _1BPXJ2Q4SZ _2C9dkJ7GSX"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9PP7.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $hekY6.default)([
            "_0fKRyPnQyn _1mT5xdWVPG"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PQfP.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $hekY6.default)([
            "_1wydGW1Y8M"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8v3AV.default), null));
};
var $9a8a2863bdf59a4a$export$2e2bcd8739ae039 = $9a8a2863bdf59a4a$var$HoverCardResolvedView;
module.exports["default"] = $9a8a2863bdf59a4a$export$2e2bcd8739ae039;

});

parcelRegister("i9PP7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $3ec5J = parcelRequire("3ec5J");


var $kjaz0 = parcelRequire("kjaz0");


var $aWJ5a = parcelRequire("aWJ5a");

/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $37cabc1db20a37d1$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $3ec5J.useFlexibleCardContext)();
    const context = (0, $kjaz0.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aWJ5a.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $37cabc1db20a37d1$export$2e2bcd8739ae039 = $37cabc1db20a37d1$var$AISummaryBlock;
module.exports["default"] = $37cabc1db20a37d1$export$2e2bcd8739ae039;

});

parcelRegister("aWJ5a", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $4yYAm = parcelRequire("4yYAm");


var $euBHF = parcelRequire("euBHF");


var $g2Qvb = parcelRequire("g2Qvb");


var $oYjIk = parcelRequire("oYjIk");


var $3qg1D = parcelRequire("3qg1D");


var $239m3 = parcelRequire("239m3");

const $9da33f5667df82ae$var$styles = null;
const $9da33f5667df82ae$var$AISummaryBlockResolvedView = (props)=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $g2Qvb.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $euBHF.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $cozmU.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, placeholder);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1"
        ])
    }, status === 'done' && /*#__PURE__*/ $cozmU.createElement((0, $239m3.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $cozmU.createElement((0, $g2Qvb.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $9da33f5667df82ae$export$2e2bcd8739ae039 = $9da33f5667df82ae$var$AISummaryBlockResolvedView;
module.exports["default"] = $9da33f5667df82ae$export$2e2bcd8739ae039;

});

parcelRegister("g2Qvb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $303LV = parcelRequire("303LV");


var $1ORf6 = parcelRequire("1ORf6");

const $3e46263f264d9f6a$var$baseStyle = null;
const $3e46263f264d9f6a$var$textStyle = null; /**
                         * A component to render a response from AI in markdown text.
                         * @internal
                         * @param {AISummaryProps} AISummaryProps
                         */ 
const $3e46263f264d9f6a$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $303LV.default), {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1T2N03wPeg _3W2Oc8wPeg _1ANEUSzUZr _2UgkTUJxkL _4cb4toJxkL _1WgujfJxkL _20VacPJxkL",
            "_1UtDYzZpcK",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $1ORf6.default)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $3e46263f264d9f6a$export$2e2bcd8739ae039 = $3e46263f264d9f6a$var$AISummary;
module.exports["default"] = $3e46263f264d9f6a$export$2e2bcd8739ae039;

});

parcelRegister("1ORf6", function(module, exports) {
/* ulist.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $d4e1b4926b40177f$var$listStyles = null;
const $d4e1b4926b40177f$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ...props,
        className: (0, $hekY6.default)([
            "_2Zuz6QkG2W _0LQT5EkG2W"
        ])
    }, children);
var $d4e1b4926b40177f$export$2e2bcd8739ae039 = $d4e1b4926b40177f$var$UList;
module.exports["default"] = $d4e1b4926b40177f$export$2e2bcd8739ae039;

});

parcelRegister("239m3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Vsq4 = parcelRequire("6Vsq4");

const $c0fca600a4237d32$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $c0fca600a4237d32$export$2e2bcd8739ae039 = $c0fca600a4237d32$var$AIEventSummaryViewed;
module.exports["default"] = $c0fca600a4237d32$export$2e2bcd8739ae039;

});

parcelRegister("9BEAr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2hRRw = parcelRequire("2hRRw");


var $voDgt = parcelRequire("voDgt");

const $109b8409b5ebe112$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $cozmU.useRef)(false);
    const previewBlockRef = (0, $cozmU.useRef)(null);
    const [showPreview, setShowPreview] = (0, $cozmU.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $cozmU.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $cozmU.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $cozmU.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $2hRRw.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $voDgt.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $109b8409b5ebe112$export$2e2bcd8739ae039 = $109b8409b5ebe112$var$ImagePreview;
module.exports["default"] = $109b8409b5ebe112$export$2e2bcd8739ae039;

});

parcelRegister("2hRRw", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");


var $4yYAm = parcelRequire("4yYAm");


var $iRL51 = parcelRequire("iRL51");

const $d2746649ad78973a$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $4yYAm.MediaType).Image,
            url: url
        } : undefined;
    }
    return (0, $iRL51.extractPreview)(response.data);
};
module.exports["extractSmartLinkPreviewImage"] = $d2746649ad78973a$export$a79836076066b8b6;

});

parcelRegister("iRL51", function(module, exports) {

var $d4O2g = parcelRequire("d4O2g");


var $4yYAm = parcelRequire("4yYAm");

const $31e8e497c67842e8$export$4b0d98b1b7f6d115 = (data)=>{
    if (!data) return undefined;
    const url = (0, $d4O2g.extractImage)(data);
    return url ? {
        type: (0, $4yYAm.MediaType).Image,
        url: url
    } : undefined;
};
module.exports["extractPreview"] = $31e8e497c67842e8$export$4b0d98b1b7f6d115;

});

parcelRegister("exTWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $htZ7r = parcelRequire("htZ7r");


var $3M4EV = parcelRequire("3M4EV");


var $3qg1D = parcelRequire("3qg1D");


var $bt1e6 = parcelRequire("bt1e6");


var $7CAOU = parcelRequire("7CAOU");

const $8119c3383e55cb16$var$loadingViewContainer = null;
const $8119c3383e55cb16$var$skeletonContainer = null;
const $8119c3383e55cb16$var$titleStyle = null;
const $8119c3383e55cb16$var$titleBlockStyles = null;
const $8119c3383e55cb16$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $7CAOU.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3M4EV.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8g1xE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _39xV02N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _0jFU0VbKFA _0VARMJN91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $8119c3383e55cb16$export$2e2bcd8739ae039 = $8119c3383e55cb16$var$HoverCardLoadingView;
module.exports["default"] = $8119c3383e55cb16$export$2e2bcd8739ae039;

});

parcelRegister("apqge", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $hHrlI = parcelRequire("hHrlI");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $h9zfZ = parcelRequire("h9zfZ");


var $4bvRC = parcelRequire("4bvRC");


var $bVAqi = parcelRequire("bVAqi");


var $3M4EV = parcelRequire("3M4EV");


var $3qg1D = parcelRequire("3qg1D");


var $hsIfr = parcelRequire("hsIfr");

const $0784325f946f0262$var$connectButtonStyles = null;
const $0784325f946f0262$var$titleBlockStyles = null;
const $0784325f946f0262$var$mainTextStyles = null;
const $0784325f946f0262$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $h9zfZ.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $cozmU.useMemo)(()=>[
            {
                name: (0, $4yYAm.ActionName).CustomAction,
                content: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), null), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $4bvRC.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-button`,
        className: (0, $hekY6.default)([
            "_37wbyuz9WS _3138422ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $0784325f946f0262$export$2e2bcd8739ae039 = $0784325f946f0262$var$HoverCardUnauthorisedView;
module.exports["default"] = $0784325f946f0262$export$2e2bcd8739ae039;

});

parcelRegister("h9zfZ", function(module, exports) {
const $f639b94581f6c899$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
module.exports["hasAuthScopeOverrides"] = $f639b94581f6c899$export$3f9446bb21b945a0;

});

parcelRegister("4bvRC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).learn_more_about_connecting_account_appify : (0, $dM7c5.messages).learn_more_about_connecting_account : (0, $dM7c5.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $dM7c5.messages).learn_more_about_connecting_account_experiment_shorter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider_appify : (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: isProductIntegrationSupported ? (0, $4yYAm.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $4yYAm.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreMessage)));
};
var $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039 = $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent;
module.exports["default"] = $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039;

});

parcelRegister("8qkhz", function(module, exports) {
/* RovoUnauthorisedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $f0b2F = parcelRequire("f0b2F");


var $kTb7m = parcelRequire("kTb7m");


var $bLfHG = parcelRequire("bLfHG");


var $hHrlI = parcelRequire("hHrlI");


var $NlHoa = parcelRequire("NlHoa");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $bVAqi = parcelRequire("bVAqi");


var $hsIfr = parcelRequire("hsIfr");


var $9jfdQ = parcelRequire("9jfdQ");


var $9Ouph = parcelRequire("9Ouph");


var $2NEHk = parcelRequire("2NEHk");

const $31dccf5742e9195b$var$ROVO_FEATURES = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_clear_link_names,
        testIdSuffix: 'clear-link-names'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_understand_linked_docs,
        testIdSuffix: 'understand-linked-docs'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_go_deeper_smart_suggestions,
        testIdSuffix: 'go-deeper-smart-suggestions'
    }
];
const $31dccf5742e9195b$var$sparkleWrapBase = null;
const $31dccf5742e9195b$var$sparkleLeftWrap = null;
const $31dccf5742e9195b$var$sparkleGreyRightWrap = null;
const $31dccf5742e9195b$var$sparkleVioletRightWrap = null;
const $31dccf5742e9195b$var$layoutStyles = {
    connectorStroke: "_1UtDYzy7kJ _3iDTPbQ4SZ _3YEZNOdnbC",
    atlassianIconTile: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXrutfbE",
    header: "_0KLXrumhAQ _0Of8r2NHnM _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO _2C2kUQ8fU6 _1Lz9lo8fU6 _1mT5xdRAKS",
    headerGraphicRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1DCdHi8HPE",
    headerTitle: "_2fwxA5DIqT",
    body: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    featureIconCell: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02ey7F",
    footer: "_2mHwu88HPE _3138428HPE _0Of8r21Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _3TGfC9HnLE"
};
const $31dccf5742e9195b$var$RovoUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, onDismiss: onDismiss, testId: testId = 'hover-card-rovo-unauthorised-view', url: url })=>{
    const providerName = (0, $cozmU.useMemo)(()=>(0, $hHrlI.extractSmartLinkProvider)(flexibleCardProps.cardState.details)?.text, [
        flexibleCardProps.cardState.details
    ]);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (onDismiss) {
            fireEvent('ui.button.clicked.dismiss', {});
            onDismiss();
        }
    }, [
        fireEvent,
        onDismiss
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId,
        ui: {
            hideElevation: true,
            hideBackground: true,
            removeBlockRestriction: true,
            hidePadding: true
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.header
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzfyEX _2IhTonuNcX _3OE6xYXJux"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9jfdQ.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzBee8 _2IhTonxpxF _4ApkO2E2XL"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Ouph.SparseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _3iDTPbQ4SZ _1mT5xdWVPG",
            "_1UtDYzJhIs _39xV02E2XL _2IhTonUF4f _4ApkO2XJux"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9jfdQ.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerGraphicRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        isTiledIcon: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.connectorStroke
    }, /*#__PURE__*/ $cozmU.createElement((0, $2NEHk.SquiglyArrow), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.atlassianIconTile
    }, /*#__PURE__*/ $cozmU.createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "inverse",
        size: "small"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        color: "color.text"
    }, providerName ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).rovo_unauthorised_title,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_title_no_provider)))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, $31dccf5742e9195b$var$ROVO_FEATURES.map((feature)=>{
        const FeatureIcon = feature.icon;
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            key: feature.testIdSuffix,
            space: "space.150",
            alignBlock: "center",
            testId: `${testId}-feature-${feature.testIdSuffix}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $31dccf5742e9195b$var$layoutStyles.featureIconCell
        }, /*#__PURE__*/ $cozmU.createElement(FeatureIcon, {
            label: ""
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), feature.message)));
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $31dccf5742e9195b$var$layoutStyles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleDismiss,
        testId: `${testId}-not-now`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_not_now)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleAuthorize,
        testId: `${testId}-connect-account`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_connect_account)))))));
};
var $31dccf5742e9195b$export$2e2bcd8739ae039 = $31dccf5742e9195b$var$RovoUnauthorisedView;
module.exports["default"] = $31dccf5742e9195b$export$2e2bcd8739ae039;

});

parcelRegister("9jfdQ", function(module, exports) {
/* DenseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

const $a8d25d25efa690f0$export$eaa6832866c251cf = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 18.1377,8.5584 C 19.820521,9.7606431 19.569624,7.0234324 19.891314,6.0724492 20.627318,4.4834923 20.654624,2.6485663 20.986387,0.9358225 20.985763,-0.63106096 19.153938,0.29529924 19.30907,1.4628594 18.581402,3.0380165 18.941526,4.9281736 18.3064,6.59809 18.189624,7.241971 17.98497,7.9130416 18.1377,8.5584 Z M 14.048,8.62872 C 16.108587,8.8291383 14.519035,6.5848441 14.323941,5.6001158 14.16595,3.856369 13.270155,2.254813 12.701225,0.60606587 11.918719,-0.74933808 10.791962,0.96396467 11.513059,1.8973545 11.672048,3.6244988 12.925689,5.0825474 13.2127,6.8456 13.436435,7.4621245 13.581302,8.1376081 14.048,8.62872 Z M 10.5438,10.7324 C 12.427639,9.875884 9.9317744,8.7259408 9.2689606,7.9718267 8.2625,6.5396335 6.6886891,5.5966404 5.36875,4.4566662 4.0131223,3.6745583 3.8966957,5.7235932 4.9866023,6.1718516 5.9867147,7.5895644 7.8032328,8.2251817 8.93219,9.61022 9.4294433,10.031063 9.9148481,10.555839 10.5438,10.7324 Z M 8.55828,14.3099 C 9.7604964,12.627122 7.023384,12.877794 6.0723265,12.556262 4.4833477,11.820331 2.6484558,11.792914 0.93570025,11.461212 c -1.5668845,6.26e-4 -0.64052126,1.832452 0.52703915,1.677318 1.5751539,0.727694 3.4653396,0.36738 5.1352306,1.00267 0.6438861,0.116827 1.314933,0.321333 1.96031,0.1687 z m 0.07008,4.0894 C 8.828733,16.338698 6.5844599,17.928323 5.5997508,18.123433 3.8560002,18.281408 2.2543901,19.1771 0.60569938,19.746162 -0.74955704,20.529217 0.96332374,21.653982 1.8969889,20.93548 3.6240071,20.774217 5.0821994,19.522267 6.84523,19.2346 7.4618123,19.010984 8.1372369,18.866007 8.62836,18.3993 Z m 2.10414,3.5072 C 9.8760472,20.022637 8.7260556,22.518484 7.9719398,23.181273 6.5393153,24.18655 5.6000777,25.76278 4.4595963,27.081513 3.6775168,28.437135 5.7265095,28.553572 6.1747816,27.463666 7.5925047,26.463552 8.2280912,24.647029 9.61315,23.5181 c 0.418283,-0.497326 0.951352,-0.985318 1.11935,-1.6116 z m 3.5775,1.9828 c -1.682815,-1.202255 -1.431924,1.534991 -1.753614,2.485976 -0.736023,1.588942 -0.763314,3.423872 -1.095073,5.136612 6.39e-4,1.566887 1.832425,0.640518 1.677317,-0.527032 0.727655,-1.57517 0.367555,-3.465328 1.00267,-5.135256 0.116772,-0.64388 0.321426,-1.314917 0.1687,-1.9603 z m 4.0891,-0.0702 c -2.060649,-0.200406 -0.470945,2.043891 -0.275873,3.028605 0.157937,1.743716 1.053669,3.345319 1.622686,4.994007 0.782496,1.355437 1.909207,-0.357878 1.188142,-1.291274 C 20.77504,28.823312 19.521385,27.365256 19.2344,25.6022 19.010647,24.985692 18.865809,24.310193 18.3991,23.8191 Z m 3.5074,-2.1038 c -1.88386,0.856461 0.611976,2.006423 1.274773,2.760542 1.006466,1.432207 2.580314,2.375182 3.90024,3.515183 1.355682,0.782012 1.472001,-1.26689 0.382153,-1.715209 C 26.463526,24.858147 24.647022,24.222555 23.5181,22.8375 23.02082,22.416678 22.53553,21.891757 21.9065,21.7153 Z m 1.9826,-3.5775 c -1.202233,1.682763 1.53485,1.432123 2.485905,1.753638 1.588978,0.735928 3.423859,0.763338 5.136608,1.095049 1.566893,-5.94e-4 0.640594,-1.832443 -0.527,-1.677317 C 29.409454,18.581486 27.519286,18.941792 25.8494,18.3065 25.205557,18.189667 24.534178,17.985164 23.8891,18.1378 Z m -0.0704,-4.0894 c -0.200405,2.06064 2.043899,0.470968 3.028605,0.275867 1.743759,-0.15797 3.345359,-1.053678 4.994083,-1.622679 1.355308,-0.782551 -0.357965,-1.909199 -1.29135,-1.188185 -1.727151,0.159054 -3.185218,1.412574 -4.948238,1.699697 -0.616574,0.223619 -1.291971,0.368616 -1.7831,0.8353 z M 21.7152,10.544 c 0.85645,1.88385 2.006449,-0.6119565 2.760542,-1.2747918 1.432624,-1.0052563 2.371905,-2.581444 3.512333,-3.9002107 C 28.770204,4.0133778 26.721159,3.8969258 26.272916,4.986848 24.855171,5.9869493 24.21954,7.8034667 22.8345,8.93243 22.416234,9.4297408 21.883198,9.917751 21.7152,10.544 Z"
    }));
};
module.exports["DenseSparkle"] = $a8d25d25efa690f0$export$eaa6832866c251cf;

});

parcelRegister("9Ouph", function(module, exports) {
/* SparseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

const $f263d0d91039d0eb$export$d4cc5913ef36e057 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "m 21.4614,9.02651 c 1.774882,1.267966 1.510442,-1.6188099 1.849578,-2.6219063 0.776223,-1.6758612 0.805105,-3.61111 1.154947,-5.41753458 C 24.447185,-0.68027653 22.513317,0.28790594 22.69688,1.5429258 21.929419,3.2042498 22.309243,5.1977402 21.6394,6.95899 21.51609,7.6380728 21.300546,8.3458903 21.4614,9.02651 Z m -9.1629,0.611 C 14.479174,9.6115402 12.55696,7.4386694 12.239238,6.4296801 11.873994,4.6211661 10.751762,3.0453042 9.9684287,1.3818975 9.0519692,0.02745097 7.9717763,1.9817201 8.8672911,2.872095 9.2298246,4.664959 10.714117,6.0484595 11.2158,7.86365 c 0.30309,0.6222222 0.536236,1.3131609 1.0827,1.77386 z M 9.02651,14.4282 c 1.267976,-1.774848 -1.6188386,-1.510386 -2.6219063,-1.849578 -1.6758612,-0.776223 -3.61111,-0.805105 -5.41753458,-1.154947 -1.66734565,0.01874 -0.69916318,1.952608 0.55585668,1.769045 1.661324,0.767461 3.6548144,0.387637 5.4160642,1.05748 0.6790828,0.12331 1.3869003,0.338854 2.06752,0.178 z m 0.79812,7.0123 C 9.6506342,19.264889 7.6156756,21.33182 6.6290172,21.715218 4.8462675,22.200193 3.3480398,23.427583 1.7425513,24.327425 0.48184315,25.389439 2.4687817,26.243895 3.3047292,25.323131 5.0679233,24.838194 6.3485808,23.265036 8.1279,22.6448 8.727623,22.296964 9.4030508,22.019757 9.82463,21.4405 Z m 4.60367,2.4235 c -1.774857,-1.267999 -1.510322,1.618845 -1.849554,2.621865 -0.776222,1.675869 -0.805026,3.611122 -1.154946,5.417535 0.01882,1.667361 1.952587,0.699167 1.769034,-0.555848 0.767463,-1.661311 0.387597,-3.654815 1.057466,-5.416052 0.123252,-0.679055 0.338956,-1.387036 0.178,-2.0675 z m 5.9772,0.261 c -2.173333,-0.211383 -0.496768,2.155705 -0.291021,3.19429 0.166568,1.839106 1.111399,3.528228 1.711458,5.267122 0.84816,1.433261 2.042749,-0.366933 1.253122,-1.36187 C 22.911487,29.402909 21.589251,27.865123 21.2864,26.0057 21.05053,25.355401 20.897759,24.642984 20.4055,24.125 Z m 4.3514,-4.2566 c -1.918413,1.03763 0.793683,2.065164 1.542216,2.81224 1.163691,1.434148 2.891651,2.307238 4.359284,3.41661 1.503797,0.716781 1.491809,-1.445265 0.281572,-1.83218 C 29.783911,22.847779 27.827538,22.311391 26.5397,20.9362 25.981077,20.526301 25.453402,20.026312 24.7569,19.8684 Z m 0.2667,-6.5645 c -0.61356,2.094147 2.024993,0.892339 3.082584,0.881972 1.837741,0.184903 3.674321,-0.429733 5.494903,-0.694759 1.566146,-0.568664 0.02093,-2.078292 -1.105917,-1.48934 -1.8201,-0.172658 -3.577509,0.836398 -5.46037,0.783027 -0.682737,0.109486 -1.416687,0.125746 -2.0112,0.5191 z"
    }));
};
module.exports["SparseSparkle"] = $f263d0d91039d0eb$export$d4cc5913ef36e057;

});

parcelRegister("2NEHk", function(module, exports) {
/* SquiglyArrow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

const $afa673f85cc859ab$export$940e84768143d382 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "31",
        height: "21",
        viewBox: "0 0 31 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 21.853446,0.12040609 C 20.167706,1.2017532 24.715673,2.4997309 25.755055,3.0673371 25.02723,3.2209011 21.984019,3.856737 20.991485,3.9633568 16.045179,5.5890307 11.446918,7.8287185 9.1072914,12.742806 7.8983204,12.284216 5.7117383,11.960731 4.1643839,12.645906 2.2323901,13.501397 0.58356937,15.13985 0.06015349,17.184987 0.06666279,19.997869 1.7741124,16.035826 2.7542112,15.14763 c 1.6305676,-1.477671 4.7339707,-2.002323 5.8717147,-1.083896 -0.6742412,2.17406 -0.7914961,6.013849 1.8803011,6.750565 2.072285,0.571408 3.768061,-1.977378 2.786707,-4.245231 C 12.524186,14.792533 11.187386,13.937797 10.469825,13.425746 12.484573,8.4842061 19.328854,5.5947574 24.21859,4.6647774 25.288915,4.5397793 29.069777,3.0700705 27.388804,4.826459 26.472831,6.3589647 23.793814,8.1658647 23.628028,9.0737265 23.1618,11.626835 26.092344,8.4605266 26.699318,7.7349157 27.826169,6.2825775 29.856947,4.4211835 30.479445,3.5562506 28.766042,2.8991905 26.575439,1.3555612 24.569756,0.89998649 23.662177,0.65006782 22.790889,0.24992986 21.853446,0.12040609 Z M 9.9983561,14.652336 C 11.498101,15.3957 13.411213,18.565161 11.127761,19.347839 9.1996093,18.911365 9.5916528,16.22149 9.9983561,14.652336 Z"
    }));
};
module.exports["SquiglyArrow"] = $afa673f85cc859ab$export$940e84768143d382;

});

parcelRegister("9YjhY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $98edeecff8d9936f$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// FIXME: ...props spreads all props to the div, including isReferenceHidden, which is not a valid prop for a div.
    // Find another way but adding exceptions with _, __, ___ etc.
    ({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};
module.exports["createCustomPopupContainer"] = $98edeecff8d9936f$export$c98f335200f1c8df;

});

parcelRegister("4JCld", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $eTTRx = parcelRequire("eTTRx");

const $8721fcf90b86ff31$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $8721fcf90b86ff31$var$LayeredLink = ({ onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $eTTRx.useMouseDownEvent)();
    return /*#__PURE__*/ $cozmU.createElement("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _0IXglfN91d _1ANEUSLRg7 _18TtmRWVPG _1BwB6vdnbC _0FuNJG7dHp",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $8721fcf90b86ff31$export$2e2bcd8739ae039 = $8721fcf90b86ff31$var$LayeredLink;
module.exports["default"] = $8721fcf90b86ff31$export$2e2bcd8739ae039;

});

parcelRegister("8x0Rv", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $iCudX = parcelRequire("iCudX");


var $1SDHS = parcelRequire("1SDHS");


var $emAbv = parcelRequire("emAbv");


var $eSImY = parcelRequire("eSImY");


var $2hRRw = parcelRequire("2hRRw");


var $7ci5e = parcelRequire("7ci5e");


var $5qAq5 = parcelRequire("5qAq5");

const $38809f2f4a0255f8$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Pending:
        case (0, $4yYAm.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                url: url
            };
        case (0, $4yYAm.SmartLinkStatus).Resolved:
            return (0, $iCudX.default)(params);
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).NotFound:
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $7ci5e.extractErrorIcon)(response, status),
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                preview: (0, $2hRRw.extractSmartLinkPreviewImage)(response),
                provider: (0, $eSImY.default)(response),
                actions: {
                    [(0, $4yYAm.InternalActionName).UnresolvedAction]: (0, $5qAq5.getRetryOptions)(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                },
                hostName: (0, $1SDHS.extractHostName)(response)
            };
    }
};
module.exports["getContextByStatus"] = $38809f2f4a0255f8$export$e68aec76e359e401;

});

parcelRegister("iCudX", function(module, exports) {

var $7LPcf = parcelRequire("7LPcf");


var $lXmY5 = parcelRequire("lXmY5");


var $cLyLO = parcelRequire("cLyLO");


var $ddzkt = parcelRequire("ddzkt");


var $cbT5r = parcelRequire("cbT5r");


var $e1RBl = parcelRequire("e1RBl");


var $ltT9o = parcelRequire("ltT9o");


var $3ewaO = parcelRequire("3ewaO");


var $4FdKz = parcelRequire("4FdKz");


var $iDrrr = parcelRequire("iDrrr");


var $brmIH = parcelRequire("brmIH");


var $4omKw = parcelRequire("4omKw");


var $6hJQj = parcelRequire("6hJQj");


var $2vANo = parcelRequire("2vANo");


var $5x8m5 = parcelRequire("5x8m5");


var $f4ti3 = parcelRequire("f4ti3");


var $18BtK = parcelRequire("18BtK");


var $djGuU = parcelRequire("djGuU");


var $1SDHS = parcelRequire("1SDHS");


var $emAbv = parcelRequire("emAbv");


var $gUbgx = parcelRequire("gUbgx");


var $9h1Sq = parcelRequire("9h1Sq");


var $6H3cI = parcelRequire("6H3cI");


var $56sVH = parcelRequire("56sVH");


var $7Nudn = parcelRequire("7Nudn");


var $d28ED = parcelRequire("d28ED");


var $k8KyO = parcelRequire("k8KyO");


var $3E4vv = parcelRequire("3E4vv");


var $eSImY = parcelRequire("eSImY");


var $dVfTo = parcelRequire("dVfTo");


var $4dY4M = parcelRequire("4dY4M");


var $2hRRw = parcelRequire("2hRRw");


var $4a27K = parcelRequire("4a27K");


var $39wTN = parcelRequire("39wTN");


var $evlkW = parcelRequire("evlkW");


var $igQUs = parcelRequire("igQUs");


var $3nUrI = parcelRequire("3nUrI");


var $hUuEd = parcelRequire("hUuEd");


var $hK6I2 = parcelRequire("hK6I2");


var $jRcFo = parcelRequire("jRcFo");


var $cAVCp = parcelRequire("cAVCp");


var $htJLv = parcelRequire("htJLv");


var $lRyKu = parcelRequire("lRyKu");


var $fCuY4 = parcelRequire("fCuY4");


var $bFriw = parcelRequire("bFriw");


var $hYTxH = parcelRequire("hYTxH");

const $3e8bfec00ff792aa$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, origin: origin, product: product, resolve: resolve, rovoConfig: rovoConfig, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, transformUrl: transformUrl, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    return {
        actions: (0, $4omKw.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            product: product,
            rovoConfig: rovoConfig,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        appliedToComponentsCount: (0, $2vANo.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $d28ED.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $f4ti3.extractAttachmentCount)(data),
        authorGroup: (0, $cLyLO.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $7LPcf.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $6hJQj.extractPersonsUpdatedBy)(data),
        commentCount: (0, $4dY4M.extractSmartLinkCommentCount)(response),
        viewCount: (0, $lRyKu.extractViewCount)(data),
        reactCount: (0, $4a27K.extractSmartLinkReactCount)(response),
        voteCount: (0, $fCuY4.extractVoteCount)(data),
        checklistProgress: (0, $18BtK.extractChecklistProgress)(data),
        createdBy: (0, $ddzkt.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $7Nudn.extractOwnedBy)(data),
        assignedTo: (0, $5x8m5.extractAssignedTo)(data),
        createdOn: (0, $cbT5r.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $djGuU.extractDueOn)(data),
        latestCommit: (0, $hYTxH.extractLatestCommit)(data),
        linkIcon: (0, $bFriw.extractSmartLinkIcon)(response),
        linkTitle: (0, $emAbv.default)(status, props.url, response, onClick, onAuxClick, onContextMenu),
        location: (0, $gUbgx.extractLocation)(data),
        modifiedBy: (0, $e1RBl.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $ltT9o.extractSmartLinkModifiedOn)(response),
        preview: (0, $2hRRw.extractSmartLinkPreviewImage)(response),
        priority: (0, $k8KyO.default)(data),
        provider: (0, $eSImY.default)(response),
        programmingLanguage: (0, $3E4vv.extractProgrammingLanguage)(data),
        readTime: (0, $dVfTo.extractReadTime)(data),
        sentOn: (0, $39wTN.extractSmartLinkSentOn)(response),
        snippet: (0, $brmIH.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $evlkW.extractSourceBranch)(data),
        state: (0, $igQUs.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined),
        subscriberCount: (0, $hK6I2.extractSubscriberCount)(data),
        subTasksProgress: (0, $hUuEd.extractSubTasksProgress)(data),
        storyPoints: (0, $3nUrI.extractStoryPoints)(data),
        targetBranch: (0, $jRcFo.extractTargetBranch)(data),
        userAttributes: (0, $htJLv.extractUserAttributes)(data),
        teamMemberCount: (0, $cAVCp.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $lXmY5.extractSmartLinkAri)(response),
        type: (0, $4FdKz.extractType)(data),
        meta: {
            objectId: (0, $9h1Sq.extractMetaObjectId)(meta),
            resourceType: (0, $6H3cI.extractMetaResourceType)(meta),
            tenantId: (0, $56sVH.extractMetaTenantId)(meta)
        },
        hostName: (0, $1SDHS.extractHostName)(response)
    };
};
var $3e8bfec00ff792aa$export$2e2bcd8739ae039 = $3e8bfec00ff792aa$var$extractFlexibleUiContext;
module.exports["default"] = $3e8bfec00ff792aa$export$2e2bcd8739ae039;

});

parcelRegister("brmIH", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");


var $39PqP = parcelRequire("39PqP");

const $d37e160250dd0643$export$8c6b9b49f358840 = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.description;
    return response?.data && (0, $39PqP.extractSummary)(response.data);
};
module.exports["extractSmartLinkSummary"] = $d37e160250dd0643$export$8c6b9b49f358840;

});

parcelRegister("39PqP", function(module, exports) {
const $0c0165a0a1a1634a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
module.exports["extractSummary"] = $0c0165a0a1a1634a$export$db5a8500f6b6286e;

});

parcelRegister("4omKw", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $6xM6r = parcelRequire("6xM6r");


var $jMbWL = parcelRequire("jMbWL");


var $fYH1Q = parcelRequire("fYH1Q");


var $524Ey = parcelRequire("524Ey");


var $h8eRG = parcelRequire("h8eRG");


var $hb494 = parcelRequire("hb494");


var $irGZZ = parcelRequire("irGZZ");


var $78FxT = parcelRequire("78FxT");

const $33660386a90b3130$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, product: product, response: response, rovoConfig: rovoConfig, transformUrl: transformUrl, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $fYH1Q.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).DownloadAction]: (0, $524Ey.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).FollowAction]: (0, $h8eRG.default)(response, actionOptions, id),
        [(0, $4yYAm.ActionName).PreviewAction]: (0, $hb494.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        [(0, $4yYAm.ActionName).AutomationAction]: (0, $jMbWL.extractAutomationAction)(response),
        [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $6xM6r.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $4yYAm.ActionName).RovoChatAction]: (0, $irGZZ.default)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            product: product,
            response: response,
            rovoConfig: rovoConfig
        }),
        [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $78FxT.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
module.exports["extractFlexibleCardActions"] = $33660386a90b3130$export$abe8d0ca1daa1755;

});

parcelRegister("6xM6r", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $98Ma9 = parcelRequire("98Ma9");


var $gD4nS = parcelRequire("gD4nS");

const $df0652b82bcf79d1$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).AISummaryAction, actionOptions) || !(0, $gD4nS.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};
module.exports["extractAISummaryAction"] = $df0652b82bcf79d1$export$e7f7a50a8b8932df;

});

parcelRegister("98Ma9", function(module, exports) {
const $0142dd557f1abf4d$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $0142dd557f1abf4d$export$2487b058456cca75;

});

parcelRegister("jMbWL", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $2292e96bf8ec69a8$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $4yYAm.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};
module.exports["extractAutomationAction"] = $2292e96bf8ec69a8$export$f913cc6abf3ec084;

});

parcelRegister("fYH1Q", function(module, exports) {

var $bVyUW = parcelRequire("bVyUW");

const $430f851bfe7512e2$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $bVyUW.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractCopyLinkClientAction"] = $430f851bfe7512e2$export$31ddd5c40039ce53;

});

parcelRegister("bVyUW", function(module, exports) {

var $3ewaO = parcelRequire("3ewaO");


var $4yYAm = parcelRequire("4yYAm");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $fggeM = parcelRequire("fggeM");


var $98Ma9 = parcelRequire("98Ma9");

const $44f9f0e7452f446b$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $4yYAm.ActionName).CopyLinkAction,
        definitionId: (0, $h5RL7.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fXZFy.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fggeM.getResourceType)(response)
    };
};
module.exports["extractInvokeCopyLinkAction"] = $44f9f0e7452f446b$export$5ec86886067a062d;

});

parcelRegister("524Ey", function(module, exports) {

var $apFwO = parcelRequire("apFwO");

const $4623e5e8ceeb2845$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $apFwO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractDownloadClientAction"] = $4623e5e8ceeb2845$export$f6c386869a352b1f;

});

parcelRegister("apFwO", function(module, exports) {

var $hoB2R = parcelRequire("hoB2R");


var $4yYAm = parcelRequire("4yYAm");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $fggeM = parcelRequire("fggeM");


var $98Ma9 = parcelRequire("98Ma9");


var $hy0ST = parcelRequire("hy0ST");


var $aTUup = parcelRequire("aTUup");

const $60e6e59f530d86aa$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hoB2R.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $hy0ST.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $4yYAm.ActionName).DownloadAction,
            definitionId: (0, $h5RL7.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $fXZFy.getExtensionKey)(response),
            id: id,
            resourceType: (0, $fggeM.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $60e6e59f530d86aa$export$ea97cd34c2ca86de;

});

parcelRegister("hy0ST", function(module, exports) {
const $5cd538bb8c35f32e$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
module.exports["downloadUrl"] = $5cd538bb8c35f32e$export$8a96edb1c96563f4;

});

parcelRegister("aTUup", function(module, exports) {
const $817aefb3251744bd$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $817aefb3251744bd$export$8f031784a3a03b23;

});

parcelRegister("h8eRG", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");


var $4FdKz = parcelRequire("4FdKz");


var $eWtDJ = parcelRequire("eWtDJ");


var $4yYAm = parcelRequire("4yYAm");


var $fXZFy = parcelRequire("fXZFy");


var $98Ma9 = parcelRequire("98Ma9");


var $dz3ZB = parcelRequire("dz3ZB");

const $6454219eec79705b$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $fXZFy.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    const type = (0, $4FdKz.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction || actionName === (0, $eWtDJ.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $jMcHR.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6454219eec79705b$export$2e2bcd8739ae039 = $6454219eec79705b$var$extractFollowAction;
module.exports["default"] = $6454219eec79705b$export$2e2bcd8739ae039;

});

parcelRegister("dz3ZB", function(module, exports) {
const $2b685e3fe936bab8$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $2b685e3fe936bab8$export$2e2bcd8739ae039 = $2b685e3fe936bab8$var$extractServerAction;
module.exports["default"] = $2b685e3fe936bab8$export$2e2bcd8739ae039;

});

parcelRegister("hb494", function(module, exports) {

var $jINxM = parcelRequire("jINxM");

const $2efe6a41c82eedcb$export$9f0d9100b079448 = (param)=>{
    const result = (0, $jINxM.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};
module.exports["extractPreviewClientAction"] = $2efe6a41c82eedcb$export$9f0d9100b079448;

});

parcelRegister("jINxM", function(module, exports) {

var $bw5Pv = parcelRequire("bw5Pv");


var $lXmY5 = parcelRequire("lXmY5");


var $8OcYi = parcelRequire("8OcYi");


var $hHrlI = parcelRequire("hHrlI");


var $7YvXl = parcelRequire("7YvXl");


var $3ewaO = parcelRequire("3ewaO");


var $esGL2 = parcelRequire("esGL2");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $4yYAm = parcelRequire("4yYAm");


var $fXZFy = parcelRequire("fXZFy");


var $98Ma9 = parcelRequire("98Ma9");


var $01k3g = parcelRequire("01k3g");


var $1qrkW = parcelRequire("1qrkW");


var $a3jaM = parcelRequire("a3jaM");


var $bGZ4m = parcelRequire("bGZ4m");


var $bFriw = parcelRequire("bFriw");


var $apFwO = parcelRequire("apFwO");


var $2FmJb = parcelRequire("2FmJb");

const $ef64dce8a68d6434$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $lXmY5.extractSmartLinkAri)(response);
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    const name = (0, $7YvXl.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $esGL2.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).PreviewAction, actionOptions)) return;
    // Restricted (e.g. cross-unit) resources must not be previewed at all — suppress
    // the action so it does not fall back to a preview modal.
    if (ari && isPreviewRestricted?.({
        ari: ari
    }) && (0, $iDrrr.fg)('preview_panel_unit_check')) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $bw5Pv.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $fXZFy.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $01k3g.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $apFwO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $2FmJb.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $1qrkW.extractIsSupportTheming)(meta),
                            isTrusted: (0, $a3jaM.extractIsTrusted)(meta),
                            linkIcon: (0, $iDrrr.fg)('platform_lp_use_generator_icon_for_provider') ? (0, $bFriw.extractSmartLinkIcon)(response) : (0, $bGZ4m.extractLinkIcon)(response),
                            providerName: (0, $hHrlI.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $8OcYi.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $7YvXl.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $4yYAm.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $ef64dce8a68d6434$export$caf83f49e52ac0bb;

});

parcelRegister("esGL2", function(module, exports) {

var $FR7pa = parcelRequire("FR7pa");


var $5okQI = parcelRequire("5okQI");

const $0292683c0dfc9fb7$export$24def1b22639c691 = ()=>{
    return (0, $FR7pa.isInIframe)() && (0, $5okQI.isWithinPreviewPanel)();
};
module.exports["isWithinPreviewPanelIFrame"] = $0292683c0dfc9fb7$export$24def1b22639c691;

});

parcelRegister("FR7pa", function(module, exports) {
/**
 * Checks if the current code is running inside an iframe.
 * @returns true if running in an iframe, false otherwise
 */ const $4abfd7cbb6a43538$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["isInIframe"] = $4abfd7cbb6a43538$export$9f140ed41af5108c;

});

parcelRegister("5okQI", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $8601af3d4bf0a824$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $8601af3d4bf0a824$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $8601af3d4bf0a824$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($8601af3d4bf0a824$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($8601af3d4bf0a824$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $8601af3d4bf0a824$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $8601af3d4bf0a824$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $8601af3d4bf0a824$var$getUrlSearchParams(currentSearch);
            if (currentParams && $8601af3d4bf0a824$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
module.exports["isWithinPreviewPanel"] = $8601af3d4bf0a824$export$f274fcef361fe59d;

});

parcelRegister("01k3g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $fRQ3t = parcelRequire("fRQ3t");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");

let $e71de8c9e06bc4a1$var$reactRoots = new WeakMap();
/** Mounts `element` into `mountPoint`: uses the React 18/19 `createRoot` API when `nike_r19_render_unmount` is on, else the legacy render path. */ const $e71de8c9e06bc4a1$var$renderToMountPoint = (element, mountPoint)=>{
    if ((0, $iDrrr.fg)('nike_r19_render_unmount')) {
        let root = $e71de8c9e06bc4a1$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $fRQ3t.createRoot)(mountPoint);
            $e71de8c9e06bc4a1$var$reactRoots.set(mountPoint, root);
        }
        root.render(element);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(element, mountPoint);
};
/** Unmounts the tree at `mountPoint`: uses `root.unmount()` when `nike_r19_render_unmount` is on, else the legacy unmount path. */ const $e71de8c9e06bc4a1$var$unmountFromMountPoint = (mountPoint)=>{
    if ((0, $iDrrr.fg)('nike_r19_render_unmount')) {
        const root = $e71de8c9e06bc4a1$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $e71de8c9e06bc4a1$var$reactRoots.delete(mountPoint);
        }
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(mountPoint);
};
const $e71de8c9e06bc4a1$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $e71de8c9e06bc4a1$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("jVy1T"));
    $e71de8c9e06bc4a1$var$renderToMountPoint(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal.default, {
        ...props,
        iframeName: $e71de8c9e06bc4a1$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) $e71de8c9e06bc4a1$var$unmountFromMountPoint(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}
module.exports["openEmbedModal"] = $e71de8c9e06bc4a1$export$7859f96cd8cff034;

});

parcelRegister("jVy1T", function(module, exports) {

let $e81dbcc3c7626a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e81dbcc3c7626a03$var$load("crfrC"),
    $e81dbcc3c7626a03$var$load("6wr18"),
    $e81dbcc3c7626a03$var$load("7EjoG"),
    $e81dbcc3c7626a03$var$load("ffEVr"),
    $e81dbcc3c7626a03$var$load("hhss7"),
    $e81dbcc3c7626a03$var$load("9mGhw")
]).then(()=>parcelRequire('fGlyS'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("1qrkW", function(module, exports) {

var $y3W88 = parcelRequire("y3W88");

const $a1c6aba8f77f7afa$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $y3W88.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $a1c6aba8f77f7afa$export$38d755f52cdf4acb;

});

parcelRegister("y3W88", function(module, exports) {
const $f18cdd07bdfda1f7$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $f18cdd07bdfda1f7$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $f18cdd07bdfda1f7$export$84a73a0383f58180 = 'JiraTask';
const $f18cdd07bdfda1f7$export$c6c83963a9378a67 = 'JiraSubTask';
const $f18cdd07bdfda1f7$export$58af3c426c111a6d = 'JiraStory';
const $f18cdd07bdfda1f7$export$ac9898a63417219e = 'JiraBug';
const $f18cdd07bdfda1f7$export$54db5e3fb12e39cd = 'JiraEpic';
const $f18cdd07bdfda1f7$export$2f54a5a217202c85 = 'JiraIncident';
const $f18cdd07bdfda1f7$export$d097371052bfc411 = 'JiraServiceRequest';
const $f18cdd07bdfda1f7$export$efd9452ad16c6676 = 'JiraChange';
const $f18cdd07bdfda1f7$export$2e7e70abb5d81f67 = 'JiraProblem';
const $f18cdd07bdfda1f7$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $f18cdd07bdfda1f7$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpplatform-object-provider'
];
const $f18cdd07bdfda1f7$export$3740f371d9ab7d4 = [
    'avpplatform-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $f18cdd07bdfda1f7$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $f18cdd07bdfda1f7$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $f18cdd07bdfda1f7$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $f18cdd07bdfda1f7$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $f18cdd07bdfda1f7$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $f18cdd07bdfda1f7$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $f18cdd07bdfda1f7$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $f18cdd07bdfda1f7$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $f18cdd07bdfda1f7$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $f18cdd07bdfda1f7$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $f18cdd07bdfda1f7$export$fe44ce30fd8d131b;
module.exports["PROVIDER_KEYS_WITH_HOSTPRODUCT_CONTEXT"] = $f18cdd07bdfda1f7$export$3740f371d9ab7d4;

});

parcelRegister("a3jaM", function(module, exports) {
const $388cdc660293d4db$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $388cdc660293d4db$export$4f3ffbb500daac5a;

});

parcelRegister("bGZ4m", function(module, exports) {

var $bJ2OW = parcelRequire("bJ2OW");


var $aldDV = parcelRequire("aldDV");

const $484299d36d60807b$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $bJ2OW.default)(data, renderers);
    return {
        ...(0, $aldDV.default)(data),
        render: render
    };
};
module.exports["extractLinkIcon"] = $484299d36d60807b$export$43612bed147eae48;

});

parcelRegister("bJ2OW", function(module, exports) {
const $6d3228577637aa25$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $6d3228577637aa25$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $6d3228577637aa25$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $6d3228577637aa25$export$2e2bcd8739ae039 = $6d3228577637aa25$var$extractIconRenderer;
module.exports["default"] = $6d3228577637aa25$export$2e2bcd8739ae039;

});

parcelRegister("aldDV", function(module, exports) {

var $jqhMF = parcelRequire("jqhMF");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $2Pj3a = parcelRequire("2Pj3a");


var $i9AjY = parcelRequire("i9AjY");


var $8mPrX = parcelRequire("8mPrX");


var $y3W88 = parcelRequire("y3W88");


var $aX5dQ = parcelRequire("aX5dQ");


var $1VjCT = parcelRequire("1VjCT");


var $jQ3fx = parcelRequire("jQ3fx");


var $7UwLu = parcelRequire("7UwLu");


var $2P0qx = parcelRequire("2P0qx");

const $d862403e920df0d6$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8mPrX.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractTaskNew = (data)=>{
    const taskTypeInfo = (0, $8mPrX.extractTaskType)(data) || {};
    const { id: id, icon: url, name: name } = taskTypeInfo;
    const taskType = id?.split('#').pop();
    const taskIconLabel = name?.trim() || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0] : type;
};
const $d862403e920df0d6$var$isJiraProvider = (provider)=>provider === (0, $y3W88.JIRA_GENERATOR_ID);
function $d862403e920df0d6$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $1VjCT.default)(fileFormat);
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const iconDescriptor = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            providerId: providerId,
            data: data
        });
        const documentTitle = (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? undefined : (0, $jqhMF.extractTitle)(data);
        const extractedDocumentTypeIcon = (0, $aX5dQ.default)(type, documentTitle, providerId);
        const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
        const urlIconNew = (0, $2P0qx.default)(data.icon, documentTypeIcon?.label);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIconNew,
            providerIcon: providerIcon
        });
    } else {
        const documentTypeIcon = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            label: label,
            providerId: providerId,
            data: data
        }) || (0, $aX5dQ.default)(type, label, providerId);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIcon,
            providerIcon: providerIcon
        });
    }
}
function $d862403e920df0d6$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    const descriptorLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : label;
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: descriptorLabel('goal')
            };
        case 'atlassian:Project':
            return {
                // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
                // But `IconType.Project` actual value is `BitBucket:Project`!
                icon: (0, $4yYAm.IconType).Project,
                label: descriptorLabel('project')
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $4yYAm.IconType).Commit,
                label: descriptorLabel('commit')
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $4yYAm.IconType).PullRequest,
                label: descriptorLabel('pull request')
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $4yYAm.IconType).Branch,
                label: descriptorLabel('branch')
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $4yYAm.IconType).Repo,
                label: descriptorLabel('repository')
            };
        case 'atlassian:Task':
            if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: descriptorLabel('task')
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTaskNew(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType);
                }
                return taskIconDescriptor;
            } else {
                const taskLabel = label || 'Task';
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: taskLabel
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTask(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType, taskLabel);
                }
                return taskIconDescriptor;
            }
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $d862403e920df0d6$var$extractJsonldDataIcon = (data)=>{
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const type = $d862403e920df0d6$var$extractType(data);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            type: type,
            data: data,
            providerIcon: providerIcon
        });
    } else {
        const label = (0, $jqhMF.extractTitle)(data);
        const type = $d862403e920df0d6$var$extractType(data);
        const urlIcon = (0, $2P0qx.default)(data.icon, label);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            urlIcon: urlIcon,
            providerIcon: providerIcon,
            type: type,
            label: label,
            data: data
        });
    }
};
var $d862403e920df0d6$export$2e2bcd8739ae039 = $d862403e920df0d6$var$extractJsonldDataIcon;
module.exports["default"] = $d862403e920df0d6$export$2e2bcd8739ae039;

});

parcelRegister("2Pj3a", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $4e81f2f1044982ba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $4e81f2f1044982ba$export$65e47eb22a387a86;

});

parcelRegister("i9AjY", function(module, exports) {
const $936fbc58b48eda25$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $936fbc58b48eda25$export$e0deaeb4a2dfe2b4;

});

parcelRegister("8mPrX", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $d0bc942c0997c3eb$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $d0bc942c0997c3eb$export$ed3fd59180514d27;

});

parcelRegister("aX5dQ", function(module, exports) {

var $c1Kdq = parcelRequire("c1Kdq");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $3153f71083dbedd3$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    const getLabel = (hardcodedLabel)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label;
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $4yYAm.IconType).Blog,
                label: getLabel('blog')
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $c1Kdq.isConfluenceGenerator)(providerId)) return {
                icon: (0, $4yYAm.IconType).LiveDocument,
                label: getLabel('live document')
            };
            else return {
                icon: (0, $4yYAm.IconType).File,
                label: getLabel('file')
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Presentation,
                label: getLabel('presentation')
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Spreadsheet,
                label: getLabel('spreadsheet')
            };
        case 'atlassian:Template':
            return {
                icon: (0, $4yYAm.IconType).Template,
                label: getLabel('template')
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        default:
            return undefined;
    }
};
var $3153f71083dbedd3$export$2e2bcd8739ae039 = $3153f71083dbedd3$var$extractDocumentTypeIcon;
module.exports["default"] = $3153f71083dbedd3$export$2e2bcd8739ae039;

});

parcelRegister("1VjCT", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");

const $58ae73a79d15b91a$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return getIconDescriptor((0, $4yYAm.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $4yYAm.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $4yYAm.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $4yYAm.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $4yYAm.IconType).Spreadsheet, 'spreadsheet');
        // Google Drive
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleSlides, 'google slide');
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $4yYAm.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $4yYAm.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $4yYAm.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $4yYAm.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $4yYAm.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $4yYAm.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $4yYAm.IconType).Video, 'video');
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $4yYAm.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $4yYAm.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $4yYAm.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $4yYAm.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
            return getIconDescriptor((0, $4yYAm.IconType).Generic, 'file');
        case 'application/invision.prototype':
            return getIconDescriptor((0, $4yYAm.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $58ae73a79d15b91a$export$2e2bcd8739ae039 = $58ae73a79d15b91a$var$extractFileFormatIcon;
module.exports["default"] = $58ae73a79d15b91a$export$2e2bcd8739ae039;

});

parcelRegister("jQ3fx", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");

const $616c5048633b5d21$var$extractJiraTaskIcon = (taskType, label)=>{
    const getLabel = (hardcodedLabel)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label || 'Task';
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $4yYAm.IconType).Bug,
                label: getLabel('Bug')
            };
        case 'JiraChange':
            return {
                icon: (0, $4yYAm.IconType).Change,
                label: getLabel('Change')
            };
        case 'JiraEpic':
            return {
                icon: (0, $4yYAm.IconType).Epic,
                label: getLabel('Epic')
            };
        case 'JiraIncident':
            return {
                icon: (0, $4yYAm.IconType).Incident,
                label: getLabel('Incident')
            };
        case 'JiraProblem':
            return {
                icon: (0, $4yYAm.IconType).Problem,
                label: getLabel('Problem')
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $4yYAm.IconType).ServiceRequest,
                label: getLabel('Service request')
            };
        case 'JiraStory':
            return {
                icon: (0, $4yYAm.IconType).Story,
                label: getLabel('Story')
            };
        case 'JiraSubTask':
            return {
                icon: (0, $4yYAm.IconType).SubTask,
                label: getLabel('Sub-task')
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: getLabel('Task')
            };
    }
};
var $616c5048633b5d21$export$2e2bcd8739ae039 = $616c5048633b5d21$var$extractJiraTaskIcon;
module.exports["default"] = $616c5048633b5d21$export$2e2bcd8739ae039;

});

parcelRegister("7UwLu", function(module, exports) {

var $jqhMF = parcelRequire("jqhMF");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");


var $2P0qx = parcelRequire("2P0qx");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $b98c3a64f7967b2a$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $jqhMF.extractTitle)(data);
    if (provider === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $2P0qx.default)(icon, label);
};
var $b98c3a64f7967b2a$export$2e2bcd8739ae039 = $b98c3a64f7967b2a$var$extractProviderIcon;
module.exports["default"] = $b98c3a64f7967b2a$export$2e2bcd8739ae039;

});

parcelRegister("2P0qx", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $21ca246200c193a5$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $2GG3F.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $21ca246200c193a5$export$2e2bcd8739ae039 = $21ca246200c193a5$var$extractUrlIcon;
module.exports["default"] = $21ca246200c193a5$export$2e2bcd8739ae039;

});

parcelRegister("bFriw", function(module, exports) {

var $kku4L = parcelRequire("kku4L");


var $kAdyG = parcelRequire("kAdyG");


var $bGZ4m = parcelRequire("bGZ4m");

const $eff755a16049c679$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entityIcon = (0, $kku4L.extractEntityIcon)(response);
        if (entityIcon) return entityIcon;
    }
    return (0, $bGZ4m.extractLinkIcon)(response, renderers);
};
module.exports["extractSmartLinkIcon"] = $eff755a16049c679$export$35040aed9264b11c;

});

parcelRegister("2FmJb", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");


var $4yYAm = parcelRequire("4yYAm");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $fggeM = parcelRequire("fggeM");


var $98Ma9 = parcelRequire("98Ma9");


var $X7dMF = parcelRequire("X7dMF");


var $aTUup = parcelRequire("aTUup");

const $eacd17f647b08bbc$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, transformUrl: transformUrl, id: id, response: response }, force)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $jMcHR.extractLink)(data);
    const viewActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>{
            const destinationUrl = transformUrl?.(url) ?? url;
            return (0, $X7dMF.openUrl)(destinationUrl);
        },
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $h5RL7.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fXZFy.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fggeM.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $eacd17f647b08bbc$export$88c5813cfbbe4e4c;

});

parcelRegister("X7dMF", function(module, exports) {
const $66706efa5570bc77$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
module.exports["openUrl"] = $66706efa5570bc77$export$a238cfe4a10e6279;

});

parcelRegister("irGZZ", function(module, exports) {

var $3ewaO = parcelRequire("3ewaO");


var $4yYAm = parcelRequire("4yYAm");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $fggeM = parcelRequire("fggeM");


var $98Ma9 = parcelRequire("98Ma9");


var $aflIU = parcelRequire("aflIU");

const $62820a0adcb55b8e$var$extractRovoChatAction = ({ actionOptions: actionOptions, appearance: appearance, id: id, product: product, response: response, rovoConfig: rovoConfig })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).RovoChatAction, actionOptions)) return;
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig?.rovoOptions);
    if (!isRovoChatEnabled) return;
    const extensionKey = (0, $fXZFy.getExtensionKey)(response);
    const url = (0, $3ewaO.extractSmartLinkUrl)(response);
    return actionOptions?.rovoChatAction?.optIn ? {
        invokeAction: {
            actionSubjectId: 'rovoChatPrompt',
            actionType: (0, $4yYAm.ActionName).RovoChatAction,
            definitionId: (0, $h5RL7.getDefinitionId)(response),
            display: appearance,
            extensionKey: extensionKey,
            id: id,
            resourceType: (0, $fggeM.getResourceType)(response)
        },
        product: product,
        url: url
    } : undefined;
};
var $62820a0adcb55b8e$export$2e2bcd8739ae039 = $62820a0adcb55b8e$var$extractRovoChatAction;
module.exports["default"] = $62820a0adcb55b8e$export$2e2bcd8739ae039;

});

parcelRegister("78FxT", function(module, exports) {

var $lXmY5 = parcelRequire("lXmY5");

const $b78fcf394208fce3$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $lXmY5.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};
module.exports["extractViewRelatedLinksAction"] = $b78fcf394208fce3$export$debae7424a0231b9;

});

parcelRegister("6hJQj", function(module, exports) {

var $4ZxtP = parcelRequire("4ZxtP");


var $9EREa = parcelRequire("9EREa");

const $bee1077b61636bdc$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $4ZxtP.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};
module.exports["extractPersonsUpdatedBy"] = $bee1077b61636bdc$export$216e4f6aa7c169b8;

});

parcelRegister("2vANo", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $82b2bb1d09dbf691$export$4356c594f5c138d6 = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:appliedToComponentsCount');
module.exports["extractAppliedToComponentsCount"] = $82b2bb1d09dbf691$export$4356c594f5c138d6;

});

parcelRegister("eso5c", function(module, exports) {
const $3ea2eebea5d67ce8$export$e66823f955487935 = (data, key)=>{
    return data?.[key];
};
module.exports["extractValue"] = $3ea2eebea5d67ce8$export$e66823f955487935;

});

parcelRegister("5x8m5", function(module, exports) {

var $6CHZa = parcelRequire("6CHZa");

const $615b77374c62e9c9$export$5546969a505305 = (data)=>{
    const person = (0, $6CHZa.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
module.exports["extractAssignedTo"] = $615b77374c62e9c9$export$5546969a505305;

});

parcelRegister("f4ti3", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $d329ff1db85df6ee$export$65362ff78a97fd8 = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:attachmentCount');
module.exports["extractAttachmentCount"] = $d329ff1db85df6ee$export$65362ff78a97fd8;

});

parcelRegister("18BtK", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $3593bb380e908960$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = (0, $eso5c.extractValue)(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
module.exports["extractChecklistProgress"] = $3593bb380e908960$export$dd980f9881b65d9c;

});

parcelRegister("djGuU", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $6ca9487fa525fd4e$export$ac56bd7a37249b48 = (data)=>(0, $eso5c.extractValue)(data, 'endTime');
module.exports["extractDueOn"] = $6ca9487fa525fd4e$export$ac56bd7a37249b48;

});

parcelRegister("1SDHS", function(module, exports) {

var $3ewaO = parcelRequire("3ewaO");

const $9830a00e8c199b86$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $3ewaO.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};
module.exports["extractHostName"] = $9830a00e8c199b86$export$f222ff3355b608d8;

});

parcelRegister("emAbv", function(module, exports) {

var $7YvXl = parcelRequire("7YvXl");


var $3ewaO = parcelRequire("3ewaO");


var $4yYAm = parcelRequire("4yYAm");

const $e366d9a2a40cc6bc$var$extractLinkTitle = (status, propUrl, response, onClick, onAuxClick, onContextMenu)=>{
    const responseUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
    const url = status === (0, $4yYAm.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $7YvXl.extractSmartLinkTitle)(response);
    const text = status === (0, $4yYAm.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        text: text,
        url: url
    };
};
var $e366d9a2a40cc6bc$export$2e2bcd8739ae039 = $e366d9a2a40cc6bc$var$extractLinkTitle;
module.exports["default"] = $e366d9a2a40cc6bc$export$2e2bcd8739ae039;

});

parcelRegister("gUbgx", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $b7fb85a7c8b93868$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = (0, $eso5c.extractValue)(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
module.exports["extractLocation"] = $b7fb85a7c8b93868$export$9df94c77b0746c3c;

});

parcelRegister("9h1Sq", function(module, exports) {
const $8d8ab32ddea47e7c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
module.exports["extractMetaObjectId"] = $8d8ab32ddea47e7c$export$bec1443e3e33b166;

});

parcelRegister("6H3cI", function(module, exports) {
const $90fffddf4d76a6b1$export$11d1314ebbee594e = (meta)=>meta.resourceType;
module.exports["extractMetaResourceType"] = $90fffddf4d76a6b1$export$11d1314ebbee594e;

});

parcelRegister("56sVH", function(module, exports) {
const $d7f53f42c770ff2a$export$92037aea7f27bf7f = (meta)=>meta.tenantId;
module.exports["extractMetaTenantId"] = $d7f53f42c770ff2a$export$92037aea7f27bf7f;

});

parcelRegister("d28ED", function(module, exports) {

var $6CHZa = parcelRequire("6CHZa");

const $742683ee02e6d65c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $6CHZa.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
module.exports["extractPersonAssignedToAsArray"] = $742683ee02e6d65c$export$edb8a7a44b91274e;

});

parcelRegister("k8KyO", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");


var $4yYAm = parcelRequire("4yYAm");

const $a743bfb81d3280a1$var$priorityMapper = {
    blocker: (0, $4yYAm.IconType).PriorityBlocker,
    critical: (0, $4yYAm.IconType).PriorityCritical,
    high: (0, $4yYAm.IconType).PriorityHigh,
    highest: (0, $4yYAm.IconType).PriorityHighest,
    low: (0, $4yYAm.IconType).PriorityLow,
    lowest: (0, $4yYAm.IconType).PriorityLowest,
    major: (0, $4yYAm.IconType).PriorityMajor,
    medium: (0, $4yYAm.IconType).PriorityMedium,
    minor: (0, $4yYAm.IconType).PriorityMinor,
    trivial: (0, $4yYAm.IconType).PriorityTrivial,
    undefined: (0, $4yYAm.IconType).PriorityUndefined
};
const $a743bfb81d3280a1$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $a743bfb81d3280a1$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $a743bfb81d3280a1$export$2e2bcd8739ae039 = $a743bfb81d3280a1$var$extractPriority;
module.exports["default"] = $a743bfb81d3280a1$export$2e2bcd8739ae039;

});

parcelRegister("3E4vv", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $2c48e45972be8030$export$43e54589935a1ff = (data)=>(0, $eso5c.extractValue)(data, 'schema:programmingLanguage');
module.exports["extractProgrammingLanguage"] = $2c48e45972be8030$export$43e54589935a1ff;

});

parcelRegister("eSImY", function(module, exports) {

var $hHrlI = parcelRequire("hHrlI");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");

const $fcaa8ed9f9022e61$var$extractProvider = (response)=>{
    const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
    if (!provider) return;
    const providerName = provider.text;
    if (provider.id === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: providerName || 'Confluence'
    };
    if (provider.id === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: providerName || 'Jira'
    };
    if (providerName) return {
        label: providerName,
        url: typeof provider.icon === 'string' ? provider.icon : undefined
    };
};
var $fcaa8ed9f9022e61$export$2e2bcd8739ae039 = $fcaa8ed9f9022e61$var$extractProvider;
module.exports["default"] = $fcaa8ed9f9022e61$export$2e2bcd8739ae039;

});

parcelRegister("dVfTo", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $94823cc93685d724$export$cc4028b2878d0675 = (data)=>{
    return (0, $eso5c.extractValue)(data, 'atlassian:readTimeInMinutes');
};
module.exports["extractReadTime"] = $94823cc93685d724$export$cc4028b2878d0675;

});

parcelRegister("4dY4M", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");


var $9BmI4 = parcelRequire("9BmI4");

const $dea40d732191edf8$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && (0, $9BmI4.extractCommentCount)(response?.data);
};
module.exports["extractSmartLinkCommentCount"] = $dea40d732191edf8$export$fb0960a89fb9c17b;

});

parcelRegister("9BmI4", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $6ce3ea9514247c0d$export$b68822b76d5d51d5 = (data)=>(0, $eso5c.extractValue)(data, 'schema:commentCount');
module.exports["extractCommentCount"] = $6ce3ea9514247c0d$export$b68822b76d5d51d5;

});

parcelRegister("4a27K", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");


var $zhE44 = parcelRequire("zhE44");

const $fb6b5ea8fb58dfc8$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && (0, $zhE44.extractReactCount)(response?.data);
};
module.exports["extractSmartLinkReactCount"] = $fb6b5ea8fb58dfc8$export$bb52c21c67a309ca;

});

parcelRegister("zhE44", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $fe290e879c6996aa$export$44130aa92252501 = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:reactCount');
module.exports["extractReactCount"] = $fe290e879c6996aa$export$44130aa92252501;

});

parcelRegister("39wTN", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");


var $dQVWW = parcelRequire("dQVWW");

const $69e68ec09aa62339$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $dQVWW.extractSentOn)(response?.data);
};
module.exports["extractSmartLinkSentOn"] = $69e68ec09aa62339$export$5c05c5b7ca37e36e;

});

parcelRegister("dQVWW", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $a0d97aea7207c0d7$export$b592ddecae70b61d = (data)=>{
    return (0, $eso5c.extractValue)(data, 'dateSent');
};
module.exports["extractSentOn"] = $a0d97aea7207c0d7$export$b592ddecae70b61d;

});

parcelRegister("evlkW", function(module, exports) {

var $kOCHw = parcelRequire("kOCHw");

const $44010ae22efad87d$export$949ac6a8325b3fdb = (data)=>(0, $kOCHw.extractLinkName)(data['atlassian:mergeSource']);
module.exports["extractSourceBranch"] = $44010ae22efad87d$export$949ac6a8325b3fdb;

});

parcelRegister("kOCHw", function(module, exports) {
const $91717634a917322f$export$ec5923ec479b7275 = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
module.exports["extractLinkName"] = $91717634a917322f$export$ec5923ec479b7275;

});

parcelRegister("igQUs", function(module, exports) {

var $jMcHR = parcelRequire("jMcHR");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $fXZFy = parcelRequire("fXZFy");


var $98Ma9 = parcelRequire("98Ma9");


var $jINxM = parcelRequire("jINxM");


var $2Mkmh = parcelRequire("2Mkmh");


var $dz3ZB = parcelRequire("dz3ZB");

const $b2b984cf2b128c1f$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $b2b984cf2b128c1f$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    const extensionKey = (0, $fXZFy.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $jMcHR.extractLink)(data);
    const invokePreviewAction = response ? (0, $jINxM.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve({
                url: url,
                isReloading: true
            }) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
            isPreviewRestricted: isPreviewRestricted
        } : undefined,
        openPreviewPanel: openPreviewPanel,
        transformUrl: transformUrl
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $b2b984cf2b128c1f$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $2Mkmh.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $b2b984cf2b128c1f$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined);
    return {
        ...lozenge,
        action: action
    };
};
var $b2b984cf2b128c1f$export$2e2bcd8739ae039 = $b2b984cf2b128c1f$var$extractState;
module.exports["default"] = $b2b984cf2b128c1f$export$2e2bcd8739ae039;

});

parcelRegister("2Mkmh", function(module, exports) {

var $4FdKz = parcelRequire("4FdKz");


var $2vpap = parcelRequire("2vpap");


var $2kOxL = parcelRequire("2kOxL");


var $77Vrx = parcelRequire("77Vrx");


var $8mPrX = parcelRequire("8mPrX");

const $e166bb124f5014dc$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4FdKz.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $2kOxL.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $77Vrx.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $e166bb124f5014dc$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $2vpap.extractState)(jsonLd);
    }
};
const $e166bb124f5014dc$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8mPrX.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};
module.exports["extractLozenge"] = $e166bb124f5014dc$export$e5da155556a77bca;

});

parcelRegister("2vpap", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

// Maps accent color short names to their corresponding background and text colors
const $29dee88bf4e3c006$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        color: "var(--ds-text-accent-blue, #1558BC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        color: "var(--ds-text-accent-gray, #505258)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
        color: "var(--ds-text-accent-orange, #9E4C00)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        color: "var(--ds-text-accent-purple, #803FA5)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $29dee88bf4e3c006$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $29dee88bf4e3c006$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $eZiNI.OMIT_STATES).includes(linkState)) return {
                text: $29dee88bf4e3c006$var$capitalize(linkState),
                appearance: (0, $eZiNI.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $29dee88bf4e3c006$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};
module.exports["extractState"] = $29dee88bf4e3c006$export$5e4074cbce6574c7;

});

parcelRegister("eZiNI", function(module, exports) {
const $6cea38ed52bda634$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $6cea38ed52bda634$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $6cea38ed52bda634$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $6cea38ed52bda634$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $6cea38ed52bda634$export$772610da74ddbc07 = [
    'current'
];
module.exports["isValidAppearance"] = $6cea38ed52bda634$export$ce6b5b303f8e3c99;
module.exports["VALID_STATES"] = $6cea38ed52bda634$export$7b1deaaad25d1dc1;
module.exports["OMIT_STATES"] = $6cea38ed52bda634$export$772610da74ddbc07;

});

parcelRegister("2kOxL", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

const $b2c263e15de4bef1$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($b2c263e15de4bef1$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $b2c263e15de4bef1$var$extractTagItem(tag);
    }
};
const $b2c263e15de4bef1$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $eZiNI.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};
module.exports["extractTag"] = $b2c263e15de4bef1$export$962a8da34cf78a4f;

});

parcelRegister("77Vrx", function(module, exports) {
const $3c63915f1609dad1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};
module.exports["extractTaskStatus"] = $3c63915f1609dad1$export$7698df1946deda72;

});

parcelRegister("3nUrI", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $a3d615f410309911$export$bdcea84d1550eb9d = (data)=>{
    return (0, $eso5c.extractValue)(data, 'atlassian:storyPoints');
};
module.exports["extractStoryPoints"] = $a3d615f410309911$export$bdcea84d1550eb9d;

});

parcelRegister("hUuEd", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $0167c6f99fbc4cf8$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = (0, $eso5c.extractValue)(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
module.exports["extractSubTasksProgress"] = $0167c6f99fbc4cf8$export$744e3a2674114c1d;

});

parcelRegister("hK6I2", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $6080af3e935822e4$export$8bd03a7beb5badf1 = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:subscriberCount');
module.exports["extractSubscriberCount"] = $6080af3e935822e4$export$8bd03a7beb5badf1;

});

parcelRegister("jRcFo", function(module, exports) {

var $kOCHw = parcelRequire("kOCHw");

const $e54c52c78a753323$export$29b0ac5d2f9890cf = (data)=>(0, $kOCHw.extractLinkName)(data['atlassian:mergeDestination']);
module.exports["extractTargetBranch"] = $e54c52c78a753323$export$29b0ac5d2f9890cf;

});

parcelRegister("cAVCp", function(module, exports) {
const $0c1033be8ad6564e$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
module.exports["extractTeamMemberCount"] = $0c1033be8ad6564e$export$9fc8706c6cb5343a;

});

parcelRegister("htJLv", function(module, exports) {
const $25307ef09972ae5a$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
module.exports["extractUserAttributes"] = $25307ef09972ae5a$export$6052f26bb463e370;

});

parcelRegister("lRyKu", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $4abb27eb8f7bc89f$export$e57334ce4738e29d = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:viewCount');
module.exports["extractViewCount"] = $4abb27eb8f7bc89f$export$e57334ce4738e29d;

});

parcelRegister("fCuY4", function(module, exports) {

var $eso5c = parcelRequire("eso5c");

const $1842e0d5d1baef4e$export$c8bef3d5e550a3a = (data)=>(0, $eso5c.extractValue)(data, 'atlassian:voteCount');
module.exports["extractVoteCount"] = $1842e0d5d1baef4e$export$c8bef3d5e550a3a;

});

parcelRegister("hYTxH", function(module, exports) {
const $22c291da19a1c245$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};
module.exports["extractLatestCommit"] = $22c291da19a1c245$export$f222392162cff0d8;

});

parcelRegister("7ci5e", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $7UwLu = parcelRequire("7UwLu");

const $5e1a01be61bd3391$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $7UwLu.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $4yYAm.IconType).Forbidden
            };
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                icon: (0, $4yYAm.IconType).Error
            };
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $4yYAm.IconType).Default
            };
    }
};
module.exports["extractErrorIcon"] = $5e1a01be61bd3391$export$bdd29be9b0395931;

});

parcelRegister("5qAq5", function(module, exports) {

var $hHrlI = parcelRequire("hHrlI");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $leSBv = parcelRequire("leSBv");


var $dM7c5 = parcelRequire("dM7c5");


var $iAWda = parcelRequire("iAWda");


var $jt5b6 = parcelRequire("jt5b6");

const $c208f5990ca6f74a$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $c208f5990ca6f74a$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hHrlI.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $iAWda.getForbiddenJsonLd)().meta;
            const access = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $c208f5990ca6f74a$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $dM7c5.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $jt5b6.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $dM7c5.messages).connect_link_account_card_name,
                onClick: (0, $jt5b6.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $dM7c5.messages).cannot_find_link
            };
    }
};
module.exports["getRetryOptions"] = $c208f5990ca6f74a$export$f3d3482baaff4bf6;

});

parcelRegister("iAWda", function(module, exports) {

var $8p295 = parcelRequire("8p295");

const $c6aa164807de7c9d$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $8p295.emptyData)
        }
    });
module.exports["getForbiddenJsonLd"] = $c6aa164807de7c9d$export$e32193033a594efb;

});


$parcel$global.rlb("a92TB")
//# sourceMappingURL=component-lazy.7334ac8b.js.map
